import { Injectable, Injector } from '@angular/core'
import { Asset } from 'src/app/platform/busines-data/Framework/Asset'
import * as THREE from '@phdsoft/three'
import { Intersection } from '@phdsoft/three'
import { GraphicsMaterials } from '../graphics/graphics-materials'
import { SurfaceElement } from 'src/app/platform/busines-data/SectionElements/StructureElements/SurfaceElement'
import { AssetManager } from 'src/app/asset-manager/asset-manager'
import { MatSnackBar } from '@angular/material/snack-bar'
import { GaugingElement } from 'src/app/platform/busines-data/SectionElements/InspectionElements/gaugingElement'
import { CameraControl } from '../graphics/graphics-camera-controler.service'
import { AssetInfoViewService } from 'src/app/template/asset-info-view/asset-info-view/asset-info-view.service'
import { CollectionService } from 'src/app/collections/collection.service'
import { WorkableElement } from 'src/app/platform/busines-data/SectionElements/WorkableElement'
import { SignalRService } from 'src/app/signalr/signalr'
import { NotificationService } from 'src/app/signalr/notification.service'
import { AssetManagerRepair } from 'src/app/asset-manager/asset-manager-repair'
import { AssetManagerInspection } from 'src/app/asset-manager/asset-manager-inspection'
import { Graphics } from '../graphics/graphics'
import { campaignTypes } from 'src/app/platform/busines-data/Campaigns/Collection'
import { ViewportCaptureService } from '@app/agentic-assistant/services/viewport-capture.service'
import { AssetStateCapture } from '../asset-state-capture.service'
import { AssetStateManager } from '../assetStateManager.service'
import { MaterialEditService } from 'src/app/material-edit/material-edit.service'

const typeIdToPriorityMap: Record<string, string> = {
  [ELEMENTSTYPESIDS.ANODE]: 'AnodeElement',
  [ELEMENTSTYPESIDS.PROTECTION]: 'ProtectionElement',
  [ELEMENTSTYPESIDS.REPAIR]: 'RepairElement',
  [ELEMENTSTYPESIDS.WEIGHTAREAELEMENT]: 'WeightAreaElement',
  [ELEMENTSTYPESIDS.CONCRETE]: 'BasicElement',
  [ELEMENTSTYPESIDS.PAINTING]: 'BasicElement',
  [ELEMENTSTYPESIDS.REFERENCELINE]: 'LinearElement',
  [ELEMENTSTYPESIDS.UNDEFINED]: 'BasicElement'
}

// Priority order for element types - highest priority first
export const elementTypePriority = [
  // Inspection Elements (highest priority)
  'SteelThicknessGaugingPoint',
  'GaugingPoint',
  'GaugingElement',
  'ProtectionElement',
  'AnodeElement',

  // Sensor Elements
  'BasicSensor',

  // Structural Connection Elements
  'StructuralConnection',

  // Repair Elements (high priority - before structural)
  'RepairElement',

  // Critical Area Elements
  'CriticalAreaElement',

  // Structural Elements (surface elements prioritized over linear)
  'SurfaceElement',
  'LinearElement',
  'PointElement',

  // Other Elements
  'BasicElement',
  'WeightAreaElement'
] as const

export function getElementTypeForPriority(element: WorkableElement): string {
  if ((element as any).isRepair || element.CreationCommandType === 'RepairElement' ||
      element.Campaign?.Type === 'RepairCampaign') {
    return 'RepairElement';
  }

  if (element.elementTypeName) {
    return element.elementTypeName;
  }

  if (element.TypeId && typeIdToPriorityMap[element.TypeId as string]) {
    return typeIdToPriorityMap[element.TypeId as string];
  }

  console.warn('Element type detection falling back to constructor.name, TypeId:', element.TypeId, 'elementTypeName:', element.elementTypeName, 'Constructor:', element.constructor.name);
  return element.constructor.name;
}
import { LinearElement } from 'src/app/platform/busines-data/SectionElements/StructureElements/LinearElement'
import { AssetManagerFilter } from 'src/app/asset-manager/asset-manager-filter'
import { ELEMENTSTYPESIDS, PERMISSIONS, SESSION_STORAGE, StorageService, User, Util } from '@phdsoft/common'
import { ChangesWorkflowService } from 'src/app/template/changes-workflow/changes-workflow.service'
import { AssetManagerElementInsertion } from 'src/app/asset-manager/asset-manager-element-insertion'
import { AssetManagerCriticalArea } from 'src/app/asset-manager/asset-manager-critical-area'
import { GaugingPoint } from 'src/app/platform/busines-data/SectionElements/InspectionElements/gaugingPoint'
import { BasicSensor } from 'src/app/platform/busines-data/SectionElements/SensorElements/BasicSensor'
import { CriticalAreaElement } from 'src/app//platform/busines-data/CriticalAreaElement/CriticalAreaElement'
import { Mutex } from 'async-mutex'
import { GeometricElement } from 'src/app/platform/busines-data/GeometricSurfaceElement'
import { StructuralElement } from 'src/app/platform/busines-data/SectionElements/StructureElements/StructuralElement'
import { SteelThicknessGaugingPoint } from 'src/app/platform/busines-data/SectionElements/InspectionElements/steelThicknessGaugingPoint'
import { RegionsService } from 'src/app/admin/services/regions.service'
import { AssetLoader } from '../Loader/AssetLoader'
import { Section } from 'src/app/platform/busines-data/Framework/Section'
import { Region } from 'src/app/platform/busines-data/Framework/Region'
import { NonWorkableElement } from 'src/app/platform/busines-data/SectionElements/NonWorkableElement'
import { AssetManagerBoxMeasureTool } from 'src/app/asset-manager/asset-manager-boxmeaurement-tool'
import { SharedStateService } from 'src/app/shared/state/shared-state.service'
import { TracingService } from '@app/admin/services/tracing.service'
import { Observable, Subject } from 'rxjs'
import { TracingFilters } from '@app/admin/pages/tracing/tracing-filters.model'
import { AssetPropertiesLoaderService } from '@app/asset-manager/asset-properties-loader.service'
import { StructuralConnection } from '@app/platform/busines-data/SectionElements/StructuralConnections/StructuralConnection'
import { MeshUtils } from '@app/platform/busines-data/Geometries/Utils/mesh-utils'
import { InspectionPointInstanceManager } from '../graphics/inspection-point-instance-manager.service'
import { resolveRegionAndSectionIds } from './region-section-resolver'
import { Modes } from '@app/platform/busines-data/Framework/mode'
import { ViewModes } from '@app/platform/busines-data/Framework/viewmodes'
import { VisualizationMode } from '@app/template/menu/menu.service'
import { ViewModeElementsService } from '@app/template/view-mode-tools/view-mode-elements/view-mode-elements.service'
import { ActionType, AssetState } from '@app/platform/busines-data/Framework/asset-state'
import { regionIdsForClickedElement } from './clicked-element-regions.util'

@Injectable({ providedIn: 'root' })
export class DTSelectionService {
  public readonly sectionSelected = new Subject<{ regionId: string; sectionId: string }>()
  public _asset: Asset
  private controls: any
  private camera: THREE.Camera
  private tolerance: number
  public selectedId: string
  public selectedObject: any
  private _selectedObject: any
  private _selectedWorkableElement: WorkableElement
  public checkBaseboard: boolean
  private selectionMutex = new Mutex()
  public elementList: any[]
  geometrics: any[]
  private lastSelectedObject: StructuralElement = null;
  private lastViewIsA: boolean = true;  // selectedElementInZoom: any = null
  elementInZoomWasCleaned: boolean = true

  private readonly legendRegenerationViewModes = [
    'ThicknessColor',
    'MaterialColor',
    'RegionColor',
    'Structure4D',
    'TypicalDetailsFamily'
  ];

  public get loadCurrentCluster(): boolean {
    return this.assetManager.loadCurrentCluster
  }
  public set loadCurrentCluster(v: boolean) {
    this.assetManager.loadCurrentCluster = v
  }

  public get selectedWorkableElement(): WorkableElement {
    return this._selectedWorkableElement
  }
  public set selectedWorkableElement(value: WorkableElement) {
    this._selectedWorkableElement = value
  }

  public get selectedObjectProperties(): any {
    return this._selectedObject
  }

  public set selectedObjectProperties(value: any) {
    this._selectedObject = value
  }

  public get checkIfBaseboardIsOpen(): any {
    return this.assetManager.templateService?.showBaseBoard
  }

  constructor(
    private graphicsMaterials: GraphicsMaterials,
    private snackBar: MatSnackBar,
    private storageService: StorageService,
    private assetManager: AssetManager,
    private assetManagerRepair: AssetManagerRepair,
    private assetManagerBoxMeasureTool: AssetManagerBoxMeasureTool,
    private assetManagerCriticalArea: AssetManagerCriticalArea,
    private assetManagerFilter: AssetManagerFilter,
    private cameraControl: CameraControl,
    private assetInfoService: AssetInfoViewService,
    private collectionService: CollectionService,
    private noticationService: NotificationService,
    private graphics: Graphics,
    private changesWorkflowService: ChangesWorkflowService,
    private assetManagerElementInsertion: AssetManagerElementInsertion,
    private regionService: RegionsService,
    private assetLoader: AssetLoader,
    private sharedStateService: SharedStateService,
    private tracingService: TracingService,
    private assetPropertiesLoaderService: AssetPropertiesLoaderService,
    private viewportCaptureService: ViewportCaptureService,
    private assetStateCapture: AssetStateCapture,
    private injector: Injector,
    private instanceManager: InspectionPointInstanceManager,
    private materialEditService: MaterialEditService,
    private assetManagerInspection: AssetManagerInspection,
  )
  {
    this.tolerance = 0
    this.offsetX = this.graphics.offsetX;
    this.offsetY = this.graphics.offsetY;
    // this.regionSelection = new RegionSelection(this.graphicsMaterials);
  }

  private _assetStateManager: AssetStateManager;
  private get assetStateManager(): AssetStateManager {
    if (!this._assetStateManager) {
      this._assetStateManager = this.injector.get(AssetStateManager);
    }
    return this._assetStateManager;
  }

  // Resolved lazily on first use, like assetStateManager: only the explorer toggles need it
  private _viewModeElementsService: ViewModeElementsService;
  private get viewModeElementsService(): ViewModeElementsService {
    if (!this._viewModeElementsService) {
      this._viewModeElementsService = this.injector.get(ViewModeElementsService);
    }
    return this._viewModeElementsService;
  }

  /**
   * Explorer toggles, after asset.reapplyNewFormatSectionVisuals: the reapply re-showed the
   * lightSection type meshes (REGIONS: all of them; MODEL: the plate), so re-apply the current
   * Elements view-mode selection / FEA default faceplate hide on top of it. Only where the
   * lightSection was re-shown (new format, MODEL/REGIONS): in SECTIONS and on old-format assets
   * the filter would force SurfaceDesign.visible = true over the structure date filter.
   */
  private reapplyElementTypeFilterOverLightSection(asset: Asset): void {
    if (!asset.isNewModelMode || asset.mode === 'SECTIONS') return
    this.viewModeElementsService.reapplyElementTypeFilter()
  }

  private _offsetX: number
  public get offsetX(): number {
    return this.graphics.offsetX
  }
  public set offsetX(v: number) {
    this._offsetX = v
  }

  private _offsetY: number
  public get offsetY(): number {
    return this.graphics.offsetY
  }
  public set offsetY(v: number) {
    this._offsetY = v
  }


  private _event : any;
  public get event() : any {
    return this._event;
  }
  public set event(v : any) {
    this._event = v;
  }


  public setCameras(camera: THREE.Camera, controls: any): void {
    this.controls = controls
    this.camera = camera
    this.assetStateCapture.setCameras(camera, controls);
    this.assetStateCapture.setAssetManager(this.assetManager);
  }

  private identifyIntersection(event: any, asset: Asset, tag: string): Intersection {
    if (event.clientX == undefined) {
      event.clientX = event.center.x
      event.clientY = event.center.y
    }
    event = event.changedTouches ? event.changedTouches[0] : event
    const mouse3D = new THREE.Vector3(
      ((event.clientX - this.offsetX) / window.innerWidth) * 2 - 1,
      -((event.clientY - this.offsetY) / window.innerHeight) * 2 + 1,
      0.5,
    )
    this.tolerance = 0
    const pixelTolerance = asset.mode === 'MODEL' || 
      asset.mode === 'REGIONS'? 0 : 10; 
    // if (asset.mode === 'SECTIONS' && this.assetManager.isTouch)
    if (
      asset.mode === 'SECTIONS' &&
      event.changedPointers &&
      event.changedPointers[0]?.pointerType !== 'mouse' /*|| this.assetManager.isTouch*/
    )
      this.tolerance = 0

    const raycaster = new THREE.Raycaster(
      undefined,
      undefined,
      undefined,
      undefined,
      // this.tolerance,
    )
    raycaster.setFromCamera(new THREE.Vector2(mouse3D.x, mouse3D.y), this.camera)
    raycaster.params = {
      Mesh: { threshold: 100 },
      Line: { threshold: 0.1 },
      LOD: {},
      Points: { threshold: 100 },
      Sprite: {},
    }
    this.tolerance = 0
    this.setCanvasHeight(this.graphics.renderer.domElement.clientHeight);

    // --- InstancedMesh early interception (SEL-01, SEL-03) ---
    // Must run BEFORE the visibleMeshes collection so InstancedMesh hits are
    // resolved to GaugingElement and returned as synthetic intersections that
    // carry object.name = element.Guid — consumed unchanged by all 13+ downstream
    // name-lookup sites.
    const instancedTargets = this.instanceManager.getRaycastTargets();
    if (instancedTargets.length > 0) {
      const instancedHits = raycaster.intersectObjects(instancedTargets, false);
      for (const hit of instancedHits) {
        if (hit.instanceId !== undefined) {
          const element = this.instanceManager.resolveInstance(
            hit.object as THREE.InstancedMesh,
            hit.instanceId,
          );
          if (element && this.instanceManager.getInstanceVisible(element)) {
            // Element resolved from InstancedMesh. Create synthetic intersection
            // with object = phantom SurfaceDesign so downstream name-lookup sites
            // see intersection.object.name === element.Guid (unchanged behavior).
            this.selectedObject = element.SurfaceDesign;
            const syntheticHit = Object.assign({}, hit, { object: element.SurfaceDesign as unknown as THREE.Object3D });
            return syntheticHit as unknown as Intersection;
          }
        }
      }
    }
    // --- end InstancedMesh interception ---

    const selectableElements =
      asset.mode == "MODEL" && asset.isLightModel == true ? asset.GetVisibleLightModel() : asset.GetVisibleGroups().
      filter(x => x.visible)
    if (asset.SensorCampaign && asset.SensorCampaign.group) {
      selectableElements.push(asset.SensorCampaign.group);
    }

    const visibleMeshes: THREE.Mesh[] = [];

    (selectableElements as THREE.Group[]).forEach(group => {
      group.traverse((obj) => {
        if (obj instanceof THREE.InstancedMesh) return; // handled by InstancedMesh interception above
        if (
          obj instanceof THREE.Mesh &&
          MeshUtils.isFullyVisible(obj) &&
          ((obj.material as THREE.Material).visible ?? true)
        ) {
          visibleMeshes.push(obj);
        }
      });
    });
    let intersects: THREE.Intersection[] = [];
    // if(asset.mode === 'MODEL' || asset.mode === 'REGIONS'){
      intersects = raycaster.intersectObjects(visibleMeshes, false)
    // }
    // else{
    //   // 2. Get camera world position
    //   const cameraPos = new THREE.Vector3();
    //   this.camera.getWorldPosition(cameraPos);
    //   const hits: { object: THREE.Mesh; distance: number }[] = [];

    //   const box = new THREE.Box3();
    //   const tempVec = new THREE.Vector3();
      
    //   visibleMeshes.forEach(mesh => {
    //     mesh.updateWorldMatrix(true, false);
      
    //     const geometry = mesh.geometry as THREE.BufferGeometry;
      
    //     // Compute and transform the bounding box
    //     if (!geometry.boundingBox) geometry.computeBoundingBox();
    //     box.copy(geometry.boundingBox!).applyMatrix4(mesh.matrixWorld);
      
    //     // Compute closest point on the box to the ray
    //     const closestPoint = raycaster.ray.closestPointToPoint(box.getCenter(tempVec), new THREE.Vector3());
      
    //     // Compute the distance from that point to the box
    //     const distToBox = box.distanceToPoint(closestPoint);
      
    //     // Compute world-space tolerance based on distance from camera to box center
    //     const distFromCamera = cameraPos.distanceTo(box.getCenter(tempVec));
    //     const tol = this.worldTolAt(distFromCamera, pixelTolerance);
      
    //     if (distToBox <= tol) {
    //       hits.push({ object: mesh, distance: distToBox });
    //     }
    //   });
      
    //   // 5. Sort and return (or use firstHit)
    //   hits.sort((a, b) => a.distance - b.distance);
    //   intersects = hits.map(hit => ({
    //     object: hit.object,
    //     distance: hit.distance,
    //     point: hit.object.position // optional: use ray.closestPointToPoint if needed
    //   }));
    // }
    // this.graphics.scene.add(new THREE.ArrowHelper(raycaster.ray.direction, raycaster.ray.origin, 20, 0xff0000));
    // if (asset.mode === 'SECTIONS') {
    //   intersects = raycaster.intersectObjects(selectableElements, false);
    // }
    if (intersects && intersects.length > 0) {
      if (asset.SensorCampaign) { // Check if SensorCampaign is defined
        var sensor = asset.SensorCampaign.Elements.find(x => x.Guid === intersects[0].object.name);
        if (sensor) {
          this.selectSensor(sensor as BasicSensor);
          return;
        }
      }
    }

    if (
      asset.mode === 'SECTIONS' ||
      (asset.mode === 'REGIONS' && this.assetManager.functionalityMode === 'INSPECTIONINSERTION') ||
      (asset.mode === 'REGIONS' && asset.lightCampaign != undefined)
    ) {
      if (intersects){
        let result = this.checkIntersection(intersects, mouse3D, asset)
        if(result){
          return result
        }
        // Raw-hit fallback (new-GLTF adaptation, 586dce93dc): hits that resolve to no
        // WorkableElement here can still carry userData identity that click() resolves
        // downstream. But while the insertion-mode selection filters are active (same
        // gate as in checkIntersection), an empty result means the candidates were
        // deliberately rejected — wrong element type, or structure while 'Set Pivot
        // Point' allows only inspection points. Resurrecting the raw hit here would
        // select exactly what the filter excluded; treat it as a background click.
        if (
          asset.mode === 'SECTIONS' &&
          (this.assetManager.functionalityMode === 'INSPECTIONINSERTION' ||
            this.assetManager.functionalityMode === 'ELEMENTINSERTION')
        ) {
          return null
        }
        return intersects[0]
      }
    }
    else if(asset.isLightModel && asset.mode === 'MODEL' && this.assetManager.functionalityMode === 'BOXWEIGHTTOOL'){
      if (intersects) return this.checkIntersectionOnLightModel(intersects, mouse3D, asset)
    }
    this.oldMousePosition = null
    this._selectedWorkableElement = null
    this.anotherType = false
    if (intersects) return intersects[0]

    return null
  }
  private canvasHeight = 0;
  private setCanvasHeight(height: number): void {
    this.canvasHeight = height;
  }
  /**
   * Traverse up the parent chain from a mesh to find regionId and sectionId.
   * New GLTF hierarchy: Mesh → SurfaceElements/LinearElements/LightSection → SectionGroup → RegionGroup
   * Old hierarchy: Mesh → SurfaceGroup(SectionId) → SectionGroup(SectionId) → RegionGroup(RegionId)
   * LightSection child: Mesh → SurfaceTypesMesh → LightSection → SectionGroup → RegionGroup
   */
  private findRegionAndSectionIds(obj: THREE.Object3D, asset: Asset): { regionId: string, sectionId: string } {
    // PhantomSurfaceDesign: no parent chain, resolve from userData
    if (!obj.parent && obj.userData?.SectionID) {
      const sectionId = obj.userData.SectionID as string;
      const region = asset.GetAllStructureRegions()?.find(r =>
        r.sections.some(s => s.Guid === sectionId)
      );
      return { regionId: region?.Guid || null, sectionId };
    }

    if (!asset.isNewModelMode) {
      // Old hierarchy: mesh.parent.parent.parent = RegionGroup, mesh.parent.parent = SectionGroup
      return {
        regionId: obj.parent?.parent?.parent?.name || null,
        sectionId: obj.parent?.parent?.name || null
      };
    }

    // New hierarchy: walk up the parent chain. Light-model meshes are parented
    // straight under the light campaign's region groups, which are distinct
    // objects from the structure regions', so both campaigns are candidates.
    const candidates: Region[] = [
      ...(asset.GetAllStructureRegions() ?? []),
      ...(asset.lightCampaign ? asset.GetLightModelRegions() : []),
    ];
    return resolveRegionAndSectionIds(obj, candidates);
  }

  public click(event: any, asset: Asset, tag: string): void {
    if (!asset) return
    this._asset = asset
    // While the change-inspection-target tool is armed, every click belongs to the
    // retarget controller: no normal selection, no mode switch and no deselect on
    // an empty click. A double tap is swallowed.
    const retarget = this.assetManagerInspection.retarget
    if (retarget?.isRetargetMode()) {
      if (tag === 'doubletap') return
      retarget.handleClick(event, asset, this.camera, this.offsetX, this.offsetY)
      return
    }
    // Hammer hands us the native PointerEvent as srcEvent; Ctrl (or Cmd on mac)
    // turns a plain click into an additive multi-selection click.
    const additive = !!(event?.srcEvent?.ctrlKey || event?.srcEvent?.metaKey || event?.ctrlKey || event?.metaKey)
    const intersection = this.identifyIntersection(event, asset, tag)
    if (intersection) {
      if (intersection.object.type == 'Sprite') {
        // console.log("Document Sprite selected")
      } else if(intersection.object?.userData?.element instanceof StructuralConnection) {
      } else {
        this.selectedObject = intersection.object
        var currentRegionId: string;
        var currentSectionId: string = null;

        if (asset.isNewModelMode) {
          const ids = this.findRegionAndSectionIds(intersection.object, asset);
          currentRegionId = ids.regionId;
          currentSectionId = ids.sectionId;
        } else if (!intersection.object.parent && intersection.object.userData?.SectionID) {
          // PhantomSurfaceDesign: no parent chain, resolve from userData
          currentSectionId = intersection.object.userData.SectionID;
          const region = asset.GetAllStructureRegions()?.find(r =>
            r.sections.some(s => s.Guid === currentSectionId)
          );
          currentRegionId = region?.Guid;
        } else if ((asset.isLightModel == true && this._asset.mode === 'MODEL' && this.assetManager.functionalityMode !== 'BOXWEIGHTTOOL') || intersection.object.parent?.parent?.parent?.name == "") {
          currentRegionId = intersection.object.parent.name;
          if (intersection.object.parent?.parent?.parent?.name == "") this._asset.mode = 'MODEL'
        }
        else if(this.assetManager.functionalityMode !== 'BOXWEIGHTTOOL') {
          currentRegionId = intersection.object.parent?.parent?.parent?.name;
        }

        if (this._asset.mode === 'MODEL') {
          this.setSelection(
            currentRegionId,
            null,
            intersection.object.name,
            asset,
            tag,
          )
        }
        else if(this.assetManager.functionalityMode !== 'BOXWEIGHTTOOL'){
          this.setSelection(
            currentRegionId,
            currentSectionId ?? intersection.object.parent?.parent?.name,
            intersection.object.name,
            asset,
            tag,
            additive,
          )
        }
      }
    } else {
      this.oldMousePosition = null
      this.anotherType = false
      // "Select more": a miss-click (empty space, or an element filtered out by the
      // Structure Type list) must not throw away the selection being built.
      if (asset.mode === 'SECTIONS' && this.assetManager.multiSelectEditActive) {
        return
      }
      if (!this.materialEditService.paintActive) {
        this.removeSelection(asset)
      }
    }
  }

  public clickToHide(event: any, asset: Asset, tag: string): void {
    if (!asset) return
    this._asset = asset
    const intersection = this.identifyIntersection(event, asset, tag)
    if (intersection) {
      this.selectedObject = intersection.object
      var currentRegionId: string;
      var currentSectionId: string = null;

      if (asset.isNewModelMode) {
        const ids = this.findRegionAndSectionIds(intersection.object, asset);
        currentRegionId = ids.regionId;
        currentSectionId = ids.sectionId;
      } else if (!intersection.object.parent && intersection.object.userData?.SectionID) {
        currentSectionId = intersection.object.userData.SectionID;
        const region = asset.GetAllStructureRegions()?.find(r =>
          r.sections.some(s => s.Guid === currentSectionId)
        );
        currentRegionId = region?.Guid;
      } else if (asset.isLightModel == true && asset.mode === 'MODEL') {
        currentRegionId = intersection.object.parent.name;
      } else {
        currentRegionId = intersection.object.parent?.parent?.parent?.name;
      }

      this.hideSelected(
        currentRegionId,
        currentSectionId ?? intersection.object.parent?.parent?.name,
        intersection.object.name,
        asset,
      )
    } else {
      this.removeSelection(asset)
    }
  }

  public doubleClick(event, asset: Asset): void { }

  public getSectionAndRegionsOnClick(event: any, asset: Asset): any {
    if (event.clientX == undefined) {
      event.clientX = event.center.x
      event.clientY = event.center.y
    }
    event = event.changedTouches ? event.changedTouches[0] : event
    const mouse3D = new THREE.Vector3(
      ((event.clientX - this.offsetX) / window.innerWidth) * 2 - 1,
      -((event.clientY - this.offsetY) / window.innerHeight) * 2 + 1,
      0.5,
    )
    const mouse2D = new THREE.Vector2(mouse3D.x, mouse3D.y)
    this.tolerance = 0

    const raycaster = new THREE.Raycaster()
    raycaster.tolerance = this.tolerance
    raycaster.setFromCamera(mouse2D, this.camera)
    raycaster.params = {
      Mesh: { threshold: 100 },
      Line: { threshold: 0.1 },
      LOD: {},
      Points: { threshold: 100 },
      Sprite: {},
    }
    this.tolerance = 0

    const selectableElements =
    asset.mode == "MODEL" && asset.isLightModel == true ? asset.GetVisibleLightModel() : asset.GetVisibleGroups().
      filter(x => x.visible)
    if (asset.SensorCampaign && asset.SensorCampaign.group) {
      selectableElements.push(asset.SensorCampaign.group);
    }

    const visibleMeshes: THREE.Mesh[] = [];

    (selectableElements as THREE.Group[]).forEach(group => {
      group.traverse((obj) => {
        if (
          obj instanceof THREE.Mesh &&
          MeshUtils.isFullyVisible(obj) &&
          ((obj.material as THREE.Material).visible ?? true)
        ) {
          visibleMeshes.push(obj);
        }
      });
    });

    let intersects = raycaster.intersectObjects(visibleMeshes, true)

    if (Util.isNullOrUndefined(intersects) || intersects.length === 0) return null

    if(asset.mode == "MODEL" && asset.isLightModel == true){
      return { sectionId: null, regionIds: [intersects[0].object.parent.name] }
    }

    if (asset.isNewModelMode) {
      const ids = this.findRegionAndSectionIds(intersects[0].object, asset);
      return { sectionId: ids.sectionId, regionIds: ids.regionId ? [ids.regionId] : [] }
    }

    const element = asset
      .getStructureAndRepairsElements(true)
      .find((x) => x.Guid === intersects[0].object.name)
    if (element) return { sectionId: element.SectionId, regionIds: regionIdsForClickedElement(element) }

    return null
  }

  private setSelectRegion(regionId: string, asset: Asset): void {
    if(this.assetManager.tracingDataLoaded || !window.navigator.onLine) {
      this.selectRegion(regionId, asset)
    }
    else {
      if(!this.assetManager.settingTracingData) {
        this.setTracingData().subscribe(() => {
          this.selectRegion(regionId, asset)
        });
      }
      else {
        this.snackBar.open('Tracing data is being loaded. Please wait...', '', {
          horizontalPosition: 'center',
          verticalPosition: 'bottom',
          duration: 7000,
        })
        return;
      }
    }
  }

  public async setSelection(
    regionId: string,
    sectionId: string,
    elementId: string,
    asset: Asset,
    tag: string,
    additive: boolean = false,
  ): Promise<void> {
    if (this.assetManager.functionalityMode === 'MERGEPLATE' &&
      this.assetManager.isMergePlateInProgress) {
      return;
    }

    switch (asset.mode) {
      case 'MODEL':
        if (tag === 'doubletap') {
          if (this.checkIfRegionIsLoadable(regionId)) {
            return;
          }
          if (this.selectedId != '') this.clearRegionSelected(this.selectedId, asset)
          this.collectionService.setInspectionLoadStatus(true)
          asset.mode = 'REGIONS'
          await this.assetLoader.loadNewRegion(regionId);

          this.setSelectRegion(regionId, asset)
          // this.assetManagerSensors.loadSensors();
          this.selectedId = ''
          asset.changeDocumentsVisibilityMode()
          this.collectionService.setInspectionLoadStatus(false)
          this.assetManager.currentSection = null
          if(this.assetManager.functionalityMode === 'BOXWEIGHTTOOL'){
            this.assetManager.setFunctionalityModeNone();
            this.assetManagerBoxMeasureTool.cancelWeightMeasurementToolMode();
          }
          this.assetManager.updateViewMode()
          if (!this.graphics.Controls.enableRotate) {
            this.assetManager.enableMultipleSelection()
          }

          this.regenerateLegendIfNeeded(asset);
        } else if (!Util.isNullOrUndefined(regionId) && this.selectedId === regionId) {
          if (this.checkIfRegionIsLoadable(regionId)) {
            return;
          }
          this.collectionService.setInspectionLoadStatus(true)
          asset.mode = 'REGIONS'
          await this.assetLoader.loadNewRegion(regionId);
          this.setSelectRegion(regionId, asset)
          // this.assetManagerSensors.loadSensors();
          this.selectedId = ''
          if(this.assetManager.functionalityMode === 'BOXWEIGHTTOOL'){
            this.assetManager.setFunctionalityModeNone();
            this.assetManagerBoxMeasureTool.cancelWeightMeasurementToolMode();
          }
          asset.changeDocumentsVisibilityMode()
          this.collectionService.setInspectionLoadStatus(false)
          this.assetManager.currentSection = null
          this.assetManager.updateViewMode()
          if (!this.graphics.Controls.enableRotate) {
            this.assetManager.enableMultipleSelection()
          }

          this.regenerateLegendIfNeeded(asset);
        } else {
          let temporalElement = asset.returnModelTemporalElement(this.selectedObject.name);
          if(temporalElement){
            this.markSelectedTemporalElement(asset, temporalElement);
          }
          else
            this.markRegionSelected(regionId, asset)
        }
        break
      case 'REGIONS':
        if (tag === 'doubletap') {
          this.clearAllElementSelected(asset)
          // if (this.selectedId != '') this.clearRegionSelected(this.selectedId, asset);
          asset.mode = 'SECTIONS'

          this.selectSection(regionId, sectionId, asset)
          this.selectedId = ''
          asset.changeDocumentsVisibilityMode()
          // if (this.assetManager.functionalityMode !== 'INSPECTIONINSERTION')
          if(this.assetManager.functionalityMode !== 'INSPECTIONINSERTION') {
            this.assetManager.enableMultipleSelection()
          }

          this.regenerateLegendIfNeeded(asset);

          // this.assetManager.currentSection = null;
        } else if (this.assetManager.functionalityMode === 'INSPECTIONINSERTION') {
          // In INSPECTIONINSERTION mode, clicking on sections should select the section, not elements
          await this.markSectionSelected(regionId, sectionId, asset)
        } else {
          if (this.selectedId === sectionId) {
            asset.mode = 'SECTIONS'
            if(this.assetManager.functionalityMode === 'BOXWEIGHTTOOL')
              this.assetManager.setFunctionalityModeNone();
            this.selectSection(regionId, sectionId, asset)
            this.selectedId = ''
            asset.changeDocumentsVisibilityMode()
            this.assetManager.enableMultipleSelection()

            this.regenerateLegendIfNeeded(asset);

            // this.assetManager.currentSection = null;
          } else {
            await this.markSectionSelected(regionId, sectionId, asset)
          }
        }
        break
      case 'SECTIONS':
        if (tag === 'doubletap') {
          if (this.selectedId === elementId) {
            this.repositionCamera();
          } else {
            this.removeSelection(asset);
            this.markElementSelected(elementId, asset);
            this.selectedId = elementId;
            this.repositionCamera();
          }
        } else {
          if (additive || this.assetManager.multiSelectEditActive ||
              this.assetManager.functionalityMode == 'MULTIPLESTRUCTURESELECTION') {
            this.setMultipleSelection(elementId, asset, false)
          }
          else if (this.materialEditService.paintActive) {
            // Paint mode: don't deselect. markElementSelected's paint gate
            // applies the brush and returns without touching _selectedObject —
            // so the properties window keeps showing the originally selected element.
            this.markElementSelected(elementId, asset);
          }
          else {
            this.removeSelection(asset);
            this.markElementSelected(elementId, asset);
            this.selectedId = this.assetManager.functionalityMode === 'MERGEPLATE'
              ? this._selectedObject?.Guid ?? ''
              : elementId;
          }
        }
        break;

      default:
        this.selectedId = '';
        break;
    }
    this.assetManager.updateViewMode()
  }

  /**
   * Additive (toggle) selection of structural elements. The clicked element is
   * added to, or removed from, assetManager.selectedElements; the first entry is
   * the primary element (the one the properties window receives as selectedObject).
   * Non-structural targets (inspection points, sensors...) fall back to the
   * normal single selection so the existing flows are untouched.
   */
  private setMultipleSelection(elementId: string, asset: Asset, asSecondaty = true) {
    const clicked = asset.getStructureAndRepairsElements(true)?.find(x => x.Guid === elementId)
    let current = this.assetManager.selectedElements ?? []
    // A plain click never fills selectedElements, so the first additive click
    // starts from the element that is currently selected instead of from nothing.
    // (A non-structural current selection makes onlyStructural false below and
    // routes the click to the regular single selection.)
    if (current.length === 0 && this.assetManager.currentSelectedElement) {
      current = [this.assetManager.currentSelectedElement]
    }
    const onlyStructural = current.every(e => e instanceof StructuralElement)
    if (!(clicked instanceof StructuralElement) || !onlyStructural) {
      // "Select more": tapping an inspection point, sensor, etc. is a miss, not a new selection.
      if (this.assetManager.multiSelectEditActive) {
        return
      }
      this.removeSelection(asset)
      this.markElementSelected(elementId, asset)
      this.selectedId = elementId
      return
    }

    const alreadySelected = current.some(e => e.Guid === elementId)
    // "Select more" Structure Type filter: disallowed types cannot be added (removal stays allowed).
    if (!alreadySelected && this.assetManager.multiSelectEditActive && !this.assetManager.isTypeAllowedForMultiSelect(clicked)) {
      return
    }
    if (alreadySelected) {
      const remaining = current.filter(e => e.Guid !== elementId)
      if (remaining.length === 0) {
        this.clearElementSelected(this.selectedId, asset, true)
        return
      }
      // Every element was brought to front when it became primary; undo it for the one leaving.
      GraphicsMaterials.restoreElementToNormal(clicked)
      this.graphics.clearOutlinedElements(false)
      this.markMultipleElementsSelected(remaining.map(e => e.Guid), asset, asSecondaty)
      this.assetManager.selectedElements = remaining
      return
    }

    this.markMultipleElementsSelected([elementId, ...current.map(e => e.Guid)], asset, asSecondaty)
    // Reassign (never mutate in place) so selectedElementsChanged and the
    // properties window input binding both see a new array reference.
    this.assetManager.selectedElements = [clicked, ...current.filter(e => e.Guid !== elementId)]
  }

  /**
   * Extends the structural multi-selection with `elements` (rectangle selection).
   * The current primary element stays primary; elements already selected are ignored.
   */
  public addStructuralElementsToSelection(elements: StructuralElement[], asset: Asset): void {
    let current = this.assetManager.selectedElements ?? []
    if (current.length === 0 && this.assetManager.currentSelectedElement) {
      current = [this.assetManager.currentSelectedElement]
    }
    if (current.length === 0 || !current.every(e => e instanceof StructuralElement)) return

    const added = (elements ?? []).filter(e => e instanceof StructuralElement && !current.some(c => c.Guid === e.Guid))
    if (added.length === 0) return

    const next = [...current, ...added]
    this.markMultipleElementsSelected(next.map(e => e.Guid), asset, false)
    this.assetManager.selectedElements = next
  }

  /**
   * "Select more" Clear: deselects every element (including the one shown in the
   * properties window) through the regular deselect path, which also restores the
   * materials/outlines and ends "Select more".
   */
  public clearMultiSelection(asset: Asset): void {
    const hasSelection = (this.assetManager.selectedElements?.length ?? 0) > 0 || !!this.assetManager.currentSelectedElement
    if (!hasSelection) return
    this.clearElementSelected(this.selectedId, asset, true)
  }

  public removeSelection(asset: Asset): void {
    switch (asset.mode) {
      case 'MODEL':
        this.clearRegionSelected(this.selectedId, asset)
        if (this.selectedObject) {
          this.clearAllElementSelected(asset);
        }
        break
      case 'REGIONS':
        if ((this.assetManager.functionalityMode === 'INSPECTIONINSERTION') || (this.selectedObject))
          this.clearAllElementSelected(asset)
        else this.clearSectionSelected(this.selectedId, asset)
        break
      case 'SECTIONS':
        this.clearElementSelected(this.selectedId, asset, true)
        break
      default:
        break
    }
  }

  public hideSelected(regionId: string, sectionId: string, elementId: string, asset: Asset): void {
    switch (asset.mode) {
      case 'MODEL':
        this.hideRegionSelected(regionId, asset)
        break
      case 'REGIONS':
        this.hideSectionSelected(regionId, sectionId, asset)
        break
      case 'SECTIONS':
        this.hideElementSelected(this.selectedId, asset)
        break
      default:
        break
    }
  }

  //#region Regions

  public selectDefaultRegion(regionId: string, asset: Asset): void {
    console.log('[SelectDefaultRegion] Called', {
      regionId,
      isLightModel: asset?.isLightModel,
      assetId: asset?.assetInfo?.AssetId,
      currentRegionGuid: this.assetManager?.currentRegion?.Guid,
      assetMode: asset?.mode,
    });
    this._asset = asset

    if (this.assetManager?.currentRegion?.Guid === regionId && asset.mode === 'REGIONS')
      return;

    // Don't force REGIONS mode if we're already in SECTIONS mode with an active section
    // This prevents disrupting scene restoration that navigated to a section
    if (asset.mode === 'SECTIONS' && this.assetManager?.currentSection?.Guid) {
      return;
    }

    this.collectionService.setInspectionLoadStatus(true)
    asset.mode = 'REGIONS'
    this.selectRegion(regionId, asset)
    // this.assetManagerSensors.loadSensors();
    this.selectedId = ''
    asset.changeDocumentsVisibilityMode()
    this.collectionService.setInspectionLoadStatus(false)

    this.regenerateLegendIfNeeded(asset);

  }

  public selectQrCodeSection(regionId: string, sectionId: string, asset: Asset): void {
    this._asset = asset
    asset.mode = 'SECTIONS'
    this.selectSection(regionId, sectionId, asset)
    this.selectedId = ''

    this.regenerateLegendIfNeeded(asset);

  }

  public setRegionSelectionFromListBox(asset: Asset, regionId: string): void {
    this.markRegionSelected(regionId, asset)
  }

  private updateAssetInfoRegions(asset: Asset): void {
    const visibleRegions = asset.isLightModel && asset.mode === 'MODEL'
      ? asset.GetStructureVisibleRegionsAndLightModel()
      : asset.GetVisibleRegions()

    this.assetInfoService.setRegionAndSections(visibleRegions)
  }

  private getRegionsForExplorerVisibility(asset: Asset, regionId: string): Region[] {
    const lightRegions = asset.lightCampaign ? asset.GetLightModelRegions().filter(Boolean) : []

    if (asset.isLightModel && asset.mode === 'MODEL' && lightRegions.length > 0) {
      return lightRegions.filter((region) => region.Guid === regionId)
    }

    const regions = asset.GetStructureRegion(regionId)?.filter(Boolean) ?? []
    if (!asset.lightCampaign || lightRegions.length === 0) {
      return regions
    }

    return regions.filter((region) => !lightRegions.includes(region))
  }

  private hideLightModelOutsideModel(asset: Asset): void {
    if (!asset.lightCampaign || asset.mode === 'MODEL') {
      return
    }

    asset.GetLightModelRegions().forEach((region) => {
      if (region) region.visible = false
    })
  }

  public checkIfRegionIsLoadable(regionId: string): boolean {
    const blobPathIndex = this._asset.assetInfo.Collections[0]?.BlobPaths.findIndex(b => b.RegionId === regionId);
    const hasValidRenderGeoPath = this._asset.assetInfo.Collections[0]?.BlobPaths[blobPathIndex]?.RenderGeoPath != null;
    // if (blobPathIndex < 0 && !hasValidRenderGeoPath) {
    if (!(blobPathIndex > -1)) { // also covers an asset without Collections (index undefined)
      this.snackBar.open('Region not loadable', '', {
        horizontalPosition: 'center',
        verticalPosition: 'top',
        duration: 3000
      });
    } else if (!hasValidRenderGeoPath) {
      // The region exists but has no 3D model yet (new region still regenerating, or its GLTF failed).
      this.snackBar.open('Region 3D model is not available yet', '', {
        horizontalPosition: 'center',
        verticalPosition: 'top',
        duration: 3000
      });
    }
    return !(blobPathIndex > -1 && hasValidRenderGeoPath);
  }

  public checkIfIsRegionLoaded(): Array<string> {
    const regionsSelected = this._asset.GetStructureVisibleRegions();//?.filter((x) => x.Guid === regionId)
    let regions: Array<string> = [];
    if (regionsSelected.length > 0) {
      for (const region of regionsSelected) {
        if (region.visible)
          regions.push(region.Guid);
      }
    }
    return regions;
  }

  public selectRegion(regionId: string, asset: Asset): void {
    console.log('[SelectRegion] Called', {
      regionId,
      isLightModel: asset?.isLightModel,
      assetId: asset?.assetInfo?.AssetId,
    });
    if (!this._asset) this._asset = asset
    this.collectionService.setInspectionLoadStatus(true)

    const assetId = asset.assetInfo.AssetId;
    let region: any;
    if (asset.StructureCampaigns) {
      region = asset.StructureCampaigns[0].regionsWorkableElements.find(
        (x) => x.Guid === regionId,
      )
      // For lightModel assets, regions live in lightCampaign rather than StructureCampaigns
      if (!region) {
        region = asset.lightCampaign?.regionsWorkableElements?.find(
          (x) => x.Guid === regionId,
        )
      }
    }
    else if (!asset.elementsProperties) region = this.regionService.getRegion(regionId);

    const existingReadiness = this.assetManagerCriticalArea.getRegionCriticalAreaReadiness(
      assetId,
      regionId,
      asset
    );
    const shouldLoadRegionProperties = !!region && !region.isPropertiesLoaded;
    let propertiesPromise: Promise<void> | undefined;

    if (region) {
      if (existingReadiness) {
        propertiesPromise = existingReadiness.promise.catch(error => {
          // A URL load may already own the full chain; a later Critical Area failure must not
          // suppress the selection effects that depend only on successfully loaded properties.
          if (region.isPropertiesLoaded) {
            return;
          }
          throw error;
        });
      } else {
        if (shouldLoadRegionProperties) {
          this.assetPropertiesLoaderService.clearRegionProperties(regionId);
        }
        propertiesPromise = shouldLoadRegionProperties
          ? this.assetManager.loadProperties([regionId], true)
          : Promise.resolve();

        const readinessPromise = propertiesPromise.then(() => {
          if (window.navigator.onLine) {
            return this.assetManagerCriticalArea.loadRegionCriticalAreas(regionId);
          }
          return undefined;
        });
        this.assetManagerCriticalArea.registerRegionCriticalAreaReadiness(
          assetId,
          regionId,
          readinessPromise,
          asset
        );
      }
    }

    let lightModelRegions;
    if (this._asset.lightCampaign) {
      lightModelRegions = asset.GetLightModelRegions();
    }

    const regionsGroupsNotSelected = asset
      .GetVisibleRegionsAllTypes()
      ?.filter((x) => x.Guid !== regionId)
    if (regionsGroupsNotSelected) {
      regionsGroupsNotSelected?.forEach((region) => {
        region.visible = false
      })
      lightModelRegions?.forEach((region) => {
        region.visible = false
      })
      if (this._asset.isLightModel && this.assetManager.asset.viewMode == 'RegionColor') {
        this.assetManager.changeToRegionsViewMode()
      }
      //this.changeRegionVisibility(regionId, asset)
      this.clearRegionSelected(regionId, asset)
      const regionsSelected = asset.GetRegionsAllTypes()?.filter((x) => x.Guid === regionId)
      if (regionsSelected) {
        const regs: { [id: string]: { visible?: boolean; sections?: { [id: string]: boolean } } } =
          {} //({ id: regionSelected.Guid, visible: regionSelected.visible });
        for (const regionSelected of regionsSelected) {
          if (asset.isNewModelMode) {
            // New model mode: use view mode methods
            if (regionSelected.isStructural) {
              regionSelected.visible = true;
              regionSelected.visibleSectionLayer = true;
              regionSelected.setViewOnRegionMode();
            } else {
              if (!asset.assetInfo.HasOverlappedGeometry)
                regionSelected.renderBorderofElements(GraphicsMaterials.borderMaterialLineBasic)
              regionSelected.visible = true;
              regionSelected.visibleAllChild = true;
              regionSelected.visibleSectionLayer = true;
              regionSelected.renderLinearElements(true);
            }
          } else {
            if (!asset.assetInfo.HasOverlappedGeometry)
              regionSelected.renderBorderofElements(GraphicsMaterials.borderMaterialLineBasic)
            regionSelected.renderLinearElements(true)
            regionSelected.visibleAllChild = true
          }
          if (regionSelected.isStructural) this.assetManager.currentRegion = regionSelected
          this.assetManager.currentRegion = regionSelected
          regs[regionSelected.Guid] = {}
          regs[regionSelected.Guid].visible = regionSelected.visible
        }
        // Repair regions are non-structural: renderBorderofElements above re-created their borders after
        // the mode switch; follow the "show section borders" setting (always shown in SECTIONS / old format)
        // was: asset.applyRepairBorderVisibility()
        // Critical-area regions are non-structural as well (same re-created borders): repairs + critical areas
        asset.applyElementOverlayBorderVisibility()

        // for (const region of regionsGroupsNotSelected) {
        //     regs[region.Guid] = {};
        //     regs[region.Guid].visible = region.visible;
        // }

        // was: this.cameraControl.setCameraPosition(regionsSelected[0].getVisibleBoundingBox())
        // A light-model region that was never loaded has no inspection/sensor scaffolding,
        // so no region may match: skip the framing instead of reading [0] of an empty list.
        if (regionsSelected.length > 0)
          this.cameraControl.setCameraPosition(regionsSelected[0].getVisibleBoundingBox())

        const state = this.assetStateCapture.captureCurrentState(asset)
        this.assetStateManager.pushState(state)

        this.regenerateLegendIfNeeded(asset);

        //Observable
        this.updateAssetInfoRegions(asset)
        this.assetInfoService.setCurrentRegionIds(asset.GetVisibleRegions().map((x) => x.Guid))
        this.sharedStateService.setAssetId(asset.assetInfo.AssetId)
        this.sharedStateService.setRegionId(regionId)
        console.log('[SelectRegion] Region lookup', {
          regionId,
          isLightModel: this.assetManager.asset?.isLightModel,
          structureWorkable: this.assetManager.asset?.StructureCampaigns?.[0]?.regionsWorkableElements?.length,
          lightCampaignWorkable: this.assetManager.asset?.lightCampaign?.regionsWorkableElements?.length,
          regionFound: !!region,
          isPropertiesLoaded: region?.isPropertiesLoaded,
        });
        if (shouldLoadRegionProperties && propertiesPromise) {
          propertiesPromise.then(() => {
            this.noticationService.addFinishedNotification('Loading properties')

            this.assetManagerRepair.loadRegionRepairs(asset.assetInfo.AssetId, regionId, this.assetManager.referenceDate).then(() => {
              this.noticationService.addFinishedNotification('Loading Repairs')
              // this.snackBar.open('Finished loading Repairs', '', {
              //     horizontalPosition: 'left',
              //     verticalPosition: 'bottom',
              //     duration: 3000
              // });
              // });
              if (this.loadCurrentCluster) {
                this.assetManagerFilter.loadCurrentInspectionPlan(regionId).then(() => {
                })
              }
              else {
                if (!window.navigator.onLine) {
                  this.assetManagerFilter.loadCurrentInspectionPlan(regionId).then(() => {
                  })
                }
              }
              this.collectionService.setInspectionLoadStatus(false);
            });

            if (window.navigator.onLine) {
              this.storageService.getItem<User>(SESSION_STORAGE.USER).then((user) => {
                var assetId = this.assetManager.asset.assetInfo.AssetId
                var assetPesmissions = user.AssetPermissions.find((x) => x.AssetId == assetId)

                if (
                  assetPesmissions &&
                  assetPesmissions.PermissionIds.includes(PERMISSIONS.DEGRADATION)
                ) {
                  if (this.assetManager.degradationMode == true) {
                    this.assetManager.toggleDegradationMode()
                  }

                  this.assetManager.toggleDegradationMode()
                }
              })
            }

            this.assetManagerElementInsertion.loadRegionElements(regionId).then(() => {
              this.assetPropertiesLoaderService.setRegionPropertiesLoaded(regionId, true);
              
              // Request live view on the last capture card once the region is ready
              this.viewportCaptureService.requestLiveView();
            })

            this.collectionService.setIsInspectionsLoadedStatus(true)
          })
        } else if (region) {
          this.assetPropertiesLoaderService.setRegionPropertiesLoaded(regionId, true);
          this.viewportCaptureService.requestLiveView();
        }
      }
    }
    this.collectionService.setInspectionLoadStatus(false)
  }

  public hideAllRegionsNotSelected() {
    const regionsGroupsNotSelected = this._asset.GetVisibleRegionsAllTypes()
    if (regionsGroupsNotSelected) {
      regionsGroupsNotSelected?.forEach((region) => {
        region.visible = false
      })
    }
  }

  public changeRegionVisibility(regionId: string, asset: Asset): void {
    if (!this._asset) this._asset = asset

    const region = this.getRegionsForExplorerVisibility(asset, regionId)
    if (region) {
      const regs: { [id: string]: { visible?: boolean; sections?: { [id: string]: boolean } } } = {}

      region?.forEach((region) => {
        if (region != undefined) {
          region.visible = !region.visible
          region.sectionsVisibility = region.visible
        }
      })
      this.clearRegionSelected(regionId, asset)
      const regionSelected = asset.GetStructureRegions()

      if (this.assetManager.asset.mode === 'REGIONS') {
        const visibleRegion = asset.GetStructureVisibleRegions()
        if (visibleRegion.length === 1) {
          this.renderLinesAndBordersForVisibleRegions(this.assetManager.asset)
          if (!visibleRegion[0].isPropertiesLoaded) {
            this.collectionService.setInspectionLoadStatus(true)
            this.assetManager.loadProperties([visibleRegion[0].Guid], true).then(() => {
              this.noticationService.addFinishedNotification('Loading properties')
            })
            this.collectionService.setInspectionLoadStatus(false)
          }
        }
      } else {
        // asset.mode = 'MODEL';
        this.clearLinesAndBordersForVisibleRegions(this.assetManager.asset)
      }
      // New format: region.sectionsVisibility above showed every section.surfaceGroup (per-element meshes);
      // re-apply the mode's sub-group visuals so MODEL/REGIONS draw the lightSection. Before the state capture.
      asset.reapplyNewFormatSectionVisuals(asset.mode)
      // was: this.viewModeElementsService.reapplyElementTypeFilter()
      this.reapplyElementTypeFilterOverLightSection(asset)
      // if (regionSelected) {
      //     for (const region of regionSelected) {
      //         regs[region.Guid] = {};
      //         regs[region.Guid].visible = region.visible;
      //     }

      //     //Observable
      this.hideLightModelOutsideModel(asset)
      this.updateAssetInfoRegions(asset)
      // }

      const state = this.assetStateCapture.captureCurrentState(asset)
      this.assetStateManager.pushState(state)

      this.regenerateLegendIfNeeded(asset);

    }
  }

  public renderLinesAndBordersForVisibleRegions(asset: Asset): void {
    const visibleRegions = asset.GetVisibleRegions()
    for (const region of visibleRegions) {
      if (!asset.assetInfo.HasOverlappedGeometry)
        region.renderBorderofElements(GraphicsMaterials.borderMaterialLineBasic)
      region.renderLinearElements(true)
    }
    // New format, REGIONS/MODEL: Section.renderBorders forced the GLTF Borders on; follow the "show section borders" setting
    asset.applySectionBorderVisibility()
  }

  public clearLinesAndBordersForVisibleRegions(asset: Asset): void {
    const visibleRegions = asset.GetVisibleRegions()
    for (const region of visibleRegions) {
      region.clearBorderofElements()
      region.renderLinearElements(false)
    }
    // New format, MODEL/REGIONS: Section.clearBorders hid the GLTF Borders; follow the "show section borders" setting
    asset.applySectionBorderVisibility()
  }

  private markRegionSelected(regionId: string, asset: Asset): void {
    if (this.selectedId != '') this.clearRegionSelected(this.selectedId, asset)
    this.selectedId = regionId
    if (asset.lightCampaign) {
      const regionsGroupsSelected = asset.GetLightModelRegions()?.find((x) => x.Guid === regionId)
      if (regionsGroupsSelected) this.graphics.addOutlineElement(regionsGroupsSelected.group);
    }
    else {
      const regionsGroupsSelected = asset.GetVisibleRegions()?.find((x) => x.Guid === regionId)
      if (regionsGroupsSelected) {
        regionsGroupsSelected.selected = true
        if (asset.isNewModelMode) {
          // New model mode: outline lightSection meshes (visible), not surfaceElements (hidden)
          for (const section of regionsGroupsSelected.sections) {
            section.lightSectionGroup?.traverse(obj => {
              if (obj instanceof THREE.Mesh && obj.visible) {
                this.graphics.addOutlineElement(obj);
              }
            });
          }
        } else {
          for (const section of regionsGroupsSelected.sections) {
            for (const obj of section.surfaceElements) {
              if (obj instanceof SurfaceElement) {
                this.graphics.addOutlineElement(obj.SurfaceDesign)
              }
            }
          }
        }
      }
    }
  }

  private clearRegionSelected(regionId: string, asset: Asset): void {
    this.selectedId = ''
    const regionsGroupsNotSelected = asset.GetVisibleRegions()?.find((x) => x.Guid === regionId)
    if (regionsGroupsNotSelected)
      this.graphicsMaterials.clearRegionAsSelected(regionsGroupsNotSelected)
    this.graphics.clearOutlinedElements()
  }

  private hideRegionSelected(regionId: string, asset: Asset): void {
    if (this.selectedId != '') this.clearRegionSelected(this.selectedId, asset)
    this.selectedId = regionId
    var regionsGroupsSelected
    if (asset.isLightModel) {
      regionsGroupsSelected = asset
        .GetLightModelRegions()
        ?.find((x) => x.Guid === regionId)
    }
    else {
      regionsGroupsSelected = asset
        .GetVisibleRegionsAllTypes()
        ?.find((x) => x.Guid === regionId)
    }
    if (regionsGroupsSelected) {
      regionsGroupsSelected.visible = false

      const state = this.assetStateCapture.captureHideState(
        asset,
        regionsGroupsSelected.group,
        null,
        regionId,
        null,
      )
      this.assetStateManager.pushState(state)
    }
  }

  //#endregion

  //#region Sections

  public async setSectionSelectionFromListBox(
    asset: Asset,
    regionId: string,
    sectionId: string,
  ): Promise<void> {
    await this.markSectionSelected(regionId, sectionId, asset)
  }

  public selectSection(regionId: string, sectionId: string, asset: Asset): void {
    const visibleRegionGroups = asset.GetVisibleRegionsAllTypes()
    if (visibleRegionGroups) {
      const secs: { [id: string]: boolean } = {}
      const regs: { [id: string]: { visible?: boolean; sections?: { [id: string]: boolean } } } = {}
      for (const visibleRegionGroup of visibleRegionGroups) {
        if (visibleRegionGroup.Guid === regionId) {
          if (visibleRegionGroup.isStructural) {
            this.assetManager.currentRegion = visibleRegionGroup
          }
          visibleRegionGroup?.sections.forEach((section) => {
            if (section.Guid !== sectionId) {
              section.visible = false
              section.linearGroup.visible = false
              section.clearBorders()
            } else {
              // Switch to SECTIONS mode: show individual elements
              if (asset.isNewModelMode) {
                section.setViewOnSectionMode();
              }
              if (section.isStructureSection) {
                this.assetManager.currentSection = section
                if (this.assetManager.currentSection.sectionNormal.equals(new THREE.Vector3())) {
                  this.assetManager.currentSection.computeSectionNormal()
                }
              }
            }
            secs[section.Guid] = section.visible
          })
        } else {
          visibleRegionGroup.visible = false
        }
        regs[visibleRegionGroup.Guid] = {}
        regs[visibleRegionGroup.Guid].visible = visibleRegionGroup.visible
        regs[visibleRegionGroup.Guid].sections = secs
      }

      this.hideLightModelOutsideModel(asset)
      this.cameraControl.setCameraForSection(
        this.assetManager.currentSection.box3,
        this.assetManager.currentSection.sectionNormal.normalize(),
        0,
      )
      const state = this.assetStateCapture.captureCurrentState(asset)
      this.assetStateManager.pushState(state)

      this.regenerateLegendIfNeeded(asset);

      //Observable
      this.updateAssetInfoRegions(asset)
      this.clearSectionSelected(sectionId, asset)
    }
  }

  public setSelectSection(regionId: string, sectionId: string, asset: Asset): void {
    const visibleRegionGroups = asset
      .GetVisibleRegionsAllTypes()
      ?.filter((x) => x.Guid === regionId)
    if (visibleRegionGroups) {
      const secs: { [id: string]: boolean } = {}
      const regs: { [id: string]: { visible?: boolean; sections?: { [id: string]: boolean } } } = {}
      for (const visibleRegionGroup of visibleRegionGroups) {
        visibleRegionGroup?.sections.forEach((section) => {
          if (section.Guid !== sectionId) {
            section.visible = false
            section.linearGroup.visible = false
            section.clearBorders()
          } else {
            section.GroupsVisibility = true
            if (section.isStructureSection) {
              section.renderBorders(GraphicsMaterials.borderMaterialLineBasic)
              this.assetManager.currentSection = section
              if (this.assetManager.currentSection.sectionNormal.equals(new THREE.Vector3())) {
                this.assetManager.currentSection.computeSectionNormal()
              }
            }
          }
          secs[section.Guid] = section.visible
        })

        regs[visibleRegionGroup.Guid] = {}
        regs[visibleRegionGroup.Guid].visible = visibleRegionGroup.visible
        regs[visibleRegionGroup.Guid].sections = secs
      }
      this.hideLightModelOutsideModel(asset)
      this.cameraControl.setCameraForSection(
        this.assetManager.currentSection.box3,
        this.assetManager.currentSection.sectionNormal.normalize(),
        0,
      )
      const state = this.assetStateCapture.captureCurrentState(asset)
      this.assetStateManager.pushState(state)

      this.regenerateLegendIfNeeded(asset);


      //Observable
      this.updateAssetInfoRegions(asset)
      this.clearSectionSelected(sectionId, asset)
      this.assetManager.updateViewMode()
    }
  }

  public changeSectionVisibility(regionId: string, sectionId: string, asset: Asset): void {
    if (!this._asset) this._asset = asset
    const region = this.getRegionsForExplorerVisibility(asset, regionId)
    if (region) {
      region?.forEach((region) => {
        if (region != undefined) {
          if (!region.visible) {
            region.visible = true
            region.sectionsVisibility = false
            if (asset.mode !== 'MODEL') {
              if (!asset.assetInfo.HasOverlappedGeometry)
                region.renderBorderofElements(GraphicsMaterials.borderMaterialLineBasic)
              region.renderLinearElements(true)
              if (region && !region.isPropertiesLoaded)
                this.assetManager.loadProperties([regionId], true).then(() => {
                  this.noticationService.addFinishedNotification('Loading properties')
                  this.assetManagerRepair
                    .loadRegionRepairs(
                      asset.assetInfo.AssetId,
                      regionId,
                      this.assetManager.referenceDate,
                    )
                    .then(() => {
                      this.noticationService.addFinishedNotification('Loading Repairs')
                      this.assetManagerFilter.loadCurrentInspectionPlan(regionId)
                      this.collectionService.setInspectionLoadStatus(false)
                    })
                  this.collectionService.setIsInspectionsLoadedStatus(true)
                })
            } else {
              region.clearBorderofElements()
              region.renderLinearElements(false)
            }
          }
          if (asset.mode === 'MODEL') region.changeSectionVisibilityModelMode(sectionId)
          else region.changeSectionVisibility(sectionId)
        }
      })
      // New format, MODEL/REGIONS: clearBorderofElements / Section.GroupsVisibility above override
      // the GLTF Borders; follow the "show section borders" setting (no-op in SECTIONS)
      asset.applySectionBorderVisibility()
      // New format: Section.GroupsVisibility / changeSectionVisibilityModelMode / sectionsVisibility above wrote
      // section.surfaceGroup (per-element meshes); re-apply the mode's sub-group visuals. Before the state capture.
      asset.reapplyNewFormatSectionVisuals(asset.mode)
      // was: this.viewModeElementsService.reapplyElementTypeFilter()
      this.reapplyElementTypeFilterOverLightSection(asset)
      this.clearRegionSelected(regionId, asset)
      // asset.changeSectionVisibility = true;
      //Observable
      this.hideLightModelOutsideModel(asset)
      this.updateAssetInfoRegions(asset)
      // const regionSelected = asset.GetStructureRegions();

      // const visibleRegionGroups = asset.GetAllStructureRegions();
      // if (visibleRegionGroups) {

      //     const regs: { [id: string]: { visible?: boolean, sections?: { [id: string]: boolean } } } = {};
      //     for (const visibleRegionGroup of visibleRegionGroups) {
      //         const secs: { [id: string]: boolean } = {};
      //         visibleRegionGroup?.sections.forEach(section => {
      //             secs[section.Guid] = section.visible;
      //         });

      //         regs[visibleRegionGroup.Guid] = {};
      //         regs[visibleRegionGroup.Guid].visible = visibleRegionGroup.visible;
      //         regs[visibleRegionGroup.Guid].sections = secs;
      //     }

      const state = this.assetStateCapture.captureCurrentState(asset)
      this.assetStateManager.pushState(state)

      this.regenerateLegendIfNeeded(asset);

      // const regionSelected = asset.GetVisibleRegions()?.find(x => x.Guid === regionId);
      // if (regionSelected) {
      // regionSelected.renderBorderofElements(this.graphicsMaterials.borderMaterialLineBasic);
      // regionSelected.renderLinearElements(true);

      // const regs: { [id: string]: { visible?: boolean, sections?: { [id: string]: boolean } } } = {}//({ id: regionSelected.Guid, visible: regionSelected.visible });
      // regs[regionSelected.Guid] = {};
      // regs[regionSelected.Guid].visible = regionSelected.visible;
      // for (const region of regionsGroupsNotSelected) {
      // regs[region.Guid] = {};
      // regs[region.Guid].visible = region.visible;
      // }
      // }
    }
  }

  // public addLoadingPropertiesNotification (){
  //   let date = new Date()
  //   var notification: NotificationModel
  //   notification.title = 'Loading Properties';
  //   notification.message = 'Finished';
  //   notification.dateTime = date.getHours().toString().padStart(2, "0") + ':' + date.getMinutes().toString().padStart(2, "0") + ':' + date.getSeconds().toString().padStart(2, "0");
  //   this.noticationService.notificationCounter++
  //   this.noticationService.notifications.unshift(notification)
  //   this.noticationService.lastNotification = notification
  // }

  // public addLoadingInspectionNotification (){
  //   let date = new Date()
  //   var notification: NotificationModel
  //   notification.title = 'Loading Inspection';
  //   notification.message = 'Finished';
  //   notification.dateTime = date.getHours().toString().padStart(2, "0") + ':' + date.getMinutes().toString().padStart(2, "0") + ':' + date.getSeconds().toString().padStart(2, "0");
  //   this.noticationService.notificationCounter++
  //   this.noticationService.notifications.unshift(notification)
  //   this.noticationService.lastNotification = notification

  // }

  private async markSectionSelected(
    regionId: string,
    sectionId: string,
    asset: Asset,
  ): Promise<void> {
    const release = await this.selectionMutex.acquire()
    try {
      if (this.selectedId != '') {
        this.clearSectionSelected(this.selectedId, asset)
      }
      this.selectedId = sectionId
      const regionSelected = this.getRegionsForExplorerVisibility(asset, regionId)
      let sectionFound = false
      if (regionSelected) {
        this.graphics.clearOutlinedElements()
        for (const regionGroup of regionSelected) {
          for (const section of regionGroup.sections) {
            section.selected = false
          }
          const section = regionGroup.sections.find((x) => x.Guid === sectionId)
          if (section) {
            sectionFound = true
            section.selected = true
            if (asset.isNewModelMode) {
              // Outline lightSection meshes for the selected section
              section.lightSectionGroup?.traverse(obj => {
                if (obj instanceof THREE.Mesh && obj.visible) {
                  this.graphics.addOutlineElement(obj);
                }
              });
            } else {
              for (const obj of section?.surfaceElements) {
                if (obj instanceof SurfaceElement && !(obj instanceof CriticalAreaElement)) {
                  if (obj.SurfaceDesign.material instanceof THREE.Material) {
                    obj.SurfaceDesign.material = obj.SurfaceDesign.material.clone()
                  } else if (Array.isArray(obj.SurfaceDesign.material)) {
                    obj.SurfaceDesign.material = obj.SurfaceDesign.material.map((m) =>
                      m instanceof THREE.Material ? m.clone() : m,
                    )
                  }
                  this.graphics.addOutlineElement(obj.SurfaceDesign)
                }
              }
            }
          }
        }
      }
      if (sectionFound) {
        this.sectionSelected.next({ regionId, sectionId })
      }
    } finally {
      release()
    }
  }

  private clearSectionSelected(sectionId: string, asset: Asset): void {
    this.selectedId = ''
    const sectionSelected = asset.GetVisibleRegions()
    if (sectionSelected) {
      for (const regionGroup of sectionSelected) {
        regionGroup.setBackToDefaultMaterial()
        this.graphicsMaterials.clearSectionAsSelected(regionGroup, sectionId)
      }
    }
    this.graphics.clearOutlinedElements()
  }

  private hideSectionSelected(regionId: string, sectionId: string, asset: Asset): void {
    if (this.selectedId != '') this.clearSectionSelected(this.selectedId, asset)
    const visibleRegionGroups = asset
      .GetVisibleRegionsAllTypes()
      ?.filter((x) => x.Guid === regionId)

    let sectionGroup: any = null

    if (visibleRegionGroups) {
      for (const visibleRegionGroup of visibleRegionGroups) {
        visibleRegionGroup?.sections.forEach((section) => {
          if (section.Guid === sectionId) {
            section.visible = false
            sectionGroup = section.group
          }
        })
        this.clearSectionSelected(sectionId, asset)
      }
      if (sectionGroup) {
        const state = this.assetStateCapture.captureHideState(
          asset,
          sectionGroup,
          null,
          regionId,
          sectionId,
        )
        this.assetStateManager.pushState(state)
      }
    }
  }



  //#endregion

  //#region Element

  public markSelectedTemporalElement(asset:Asset, temporalElement:NonWorkableElement){
    this._selectedObject = temporalElement
    // this._selectedWorkableElement = temporalElement
    this._selectedObject.mode = asset.mode
    // this.assetManager.currentSelectedElement = temporalElement
    // this.graphics.outlinePass.selectedObjects = [element.SurfaceDesign]
    this.graphics.outlineElement([temporalElement.SurfaceDesign])
  }

  public markElementSelected(elementId: string, asset: Asset): void {
    this.changesWorkflowService.clearChanges()
    this.selectedId = elementId
    const regionsSelected = asset.GetVisibleRegionsAllTypes()
    if (regionsSelected) {
      for (const regionGroup of regionsSelected) {
        let section = null

        // Legacy hierarchy: last raycasted mesh's parent chain (null-safe;
        // lightSection descendants and phantoms have no Guid-named parent.parent).
        const parentSectionId = this.selectedObject?.parent?.parent?.name
        if (parentSectionId) {
          section = regionGroup.sections.find((x) => x.Guid === parentSectionId)
        }
        // Fallback: currentSection (phantom SurfaceDesigns, stale selectedObject).
        if (!section) {
          const currentSectionId = this.assetManager.currentSection?.Guid
          if (currentSectionId) {
            section = regionGroup.sections.find((x) => x.Guid === currentSectionId)
          }
        }
        // Last resort: any visible section actually containing the element.
        if (!section || !section.surfaceElements?.some((x) => x.Guid === elementId)) {
          section = regionGroup.sections.find(
            (s) => s.visible !== false && s.surfaceElements?.some((x) => x.Guid === elementId),
          ) ?? section
        }
        if (section) {
          const element = section?.surfaceElements?.find((x) => x.Guid === elementId)
          const geometrics = section?._surfaceElements
          const linearGeometrics = section?._linearElements
          if (element) {
            const center = element.getCenter()
            this.elementList = this.sortlistDistances(center, geometrics)
            this.elementInZoomWasCleaned = false
            if (element instanceof GaugingElement) {
              // (element.SurfaceDesign.material as any).color.setHex(0xff0000);//try to change just one
              //  this.graphicsMaterials.setGaugingElementAsSelected(element);
              this.assetManager._setSelectedInspectionElement(element)
              this._selectedObject = element
              this._selectedWorkableElement = element
              this._selectedObject.mode = asset.mode
              this.assetManager.currentSelectedElement = element
              // Phase 4 (SEL-04): acquire outline proxy for GaugingElement.
              // PhantomSurfaceDesign has no isMesh=true so OutlinePass cannot detect it.
              // A real Mesh proxy positioned at the instance matrix bridges this gap.
              const proxy = this.instanceManager.acquireProxy(element as GaugingElement, this.graphics.scene);
              if (proxy) {
                this.graphics.outlineElement([proxy]);
              } else {
                // Fallback: element not in instance manager (shouldn't happen for POINT elements)
                this.graphics.outlineElement([element.SurfaceDesign]);
              }
              // this.graphics.outlinePass.visibleEdgeColor.set( '#1e72fa' );

            } else {
              // this.graphicsMaterials.setSurfaceElementAsSelected(element);
              if(this.materialEditService.paintActive && element instanceof StructuralElement){
                // Anchor element (the brush source) is locked — clicking it
                // during paint is a no-op so the user can't accidentally remove
                // the originally-edited element from the pending list.
                if (this.materialEditService.paintAnchorElementId === element.Guid) {
                  return
                }
                // Toggle: element already in the pending list -> revert it
                // visually to whatever was there before paint and drop it.
                // Otherwise paint it and add to the list.
                const existingPending = this.materialEditService.getPendingChange(element.Guid)
                if (existingPending) {
                  element.currentRenderMaterial = existingPending.originalMaterial
                  this.materialEditService.removePendingChange(element.Guid)
                } else {
                  this.materialEditService.applyBrushToElement(element)
                }
                return
              }
              else if(this.assetManager.functionalityMode == 'SECTIONCREATIONELEMENTS' && element.properties ){
                if(this.assetManager.newSectionElements == null)
                  this.assetManager.newSectionElements = []
                let index = this.assetManager.newSectionElements.findIndex(x => x.Guid === element.Guid);
                if(index === -1)
                {
                    this.assetManager.newSectionElements.push(element);
                    element.currentRenderMaterial = GraphicsMaterials.redMaterial;
                }
                else
                {
                  this.assetManager.newSectionElements.splice(index, 1);
                  element.currentRenderMaterial = element.defaultMaterial
                }

              }
              else if(this.assetManager.functionalityMode == 'MERGEPLATE' && element instanceof WorkableElement){
                this.toggleMergePlateSelection(element, asset);
                return;
              }
              this._selectedObject = element
              this._selectedWorkableElement = element
              this._selectedObject.mode = asset.mode
              this.assetManager.currentSelectedElement = element
              // this.graphics.outlinePass.selectedObjects = [element.SurfaceDesign]
              this.graphics.outlineElement([element.SurfaceDesign])

              // Changes the selection mode of a sensor
              // if (element instanceof BasicSensor) {
              //     this.graphicsMaterials.setSurfaceElementAsSelected(element);
              // } else {
              //     this.graphics.outlinePass.selectedObjects = [element.SurfaceDesign]
              // }
              // console.log("surfaceElements",element)
              // this.assetManager._setSelectedInspectionElement(null);
            }

            GraphicsMaterials.bringElementToFront(element);
          } else {
            const lineElement = section?.linearElements?.find((x) => x.Guid === elementId)
            // const center = element.getCenter()
            // this.elementList = this.sortlistDistances(center, geometrics)
            if (lineElement) {
              if(this.assetManager.functionalityMode == 'COMPLETEDFULLIDSWEB' && lineElement.properties && lineElement.properties.Geometry.WebThickness > 0){
                if(this.assetManager.currentWebCompletedId != null)
                  this.assetManager.currentWebCompletedId.currentRenderMaterial = this.assetManager.currentWebCompletedId.defaultMaterial
                this.assetManager.currentWebCompletedId = lineElement
                this.assetManager.currentWebCompletedId.currentRenderMaterial = GraphicsMaterials.greenMaterial
              }
              else if(this.assetManager.functionalityMode == 'COMPLETEDFULLIDSFLANGE' && lineElement.properties && lineElement.properties.Geometry.FlangeThickness > 0){
                if(this.assetManager.currentFlangeCompletedId != null)
                  this.assetManager.currentFlangeCompletedId.currentRenderMaterial = this.assetManager.currentFlangeCompletedId.defaultMaterial
                this.assetManager.currentFlangeCompletedId = lineElement
                this.assetManager.currentFlangeCompletedId.currentRenderMaterial = GraphicsMaterials.greenMaterial
              }
              else if(this.assetManager.functionalityMode == 'FULLIDSELEMENTS' && lineElement.properties ){
                if(this.assetManager.fullIdsElements == null)
                  this.assetManager.fullIdsElements = []
                // this.assetManager.fullIdsElements.push(lineElement)
                // lineElement.currentRenderMaterial = GraphicsMaterials.greenMaterial

                let index = this.assetManager.fullIdsElements.findIndex(x => x.Guid === lineElement.Guid);
                if(index === -1)
                {
                    this.assetManager.fullIdsElements.push(lineElement);
                    lineElement.currentRenderMaterial = GraphicsMaterials.greenMaterial;
                }
                else
                {
                  this.assetManager.fullIdsElements.splice(index, 1);
                  lineElement.currentRenderMaterial = lineElement.defaultMaterial
                }

                if(this.assetManager.fullIdElementTarget.Guid == lineElement.Guid)
                {
                  this.assetManager.fullIdElementTarget = null;
                }
              }
              else if(this.assetManager.functionalityMode == 'FULLIDSELEMENTTARGET' && lineElement.properties ){
                if(this.assetManager.fullIdElementTarget != null)
                {
                  this.assetManager.fullIdElementTarget.currentRenderMaterial = this.assetManager.fullIdElementTarget.defaultMaterial
                  this.assetManager.fullIdElementTarget = null;
                }
                else{
                  this.assetManager.fullIdElementTarget = lineElement
                  lineElement.currentRenderMaterial = GraphicsMaterials.redMaterial
                }

                let index = this.assetManager.fullIdsElements?.findIndex(x => x.Guid === lineElement.Guid);
                if(index > -1)
                {
                  this.assetManager.fullIdsElements.splice(index, 1);
                }
              }
              else if(this.assetManager.functionalityMode == 'SECTIONCREATIONELEMENTS' && lineElement.properties ){
                if(this.assetManager.newSectionElements == null)
                  this.assetManager.newSectionElements = []
                let index = this.assetManager.newSectionElements.findIndex(x => x.Guid === lineElement.Guid);
                if(index === -1)
                {
                    this.assetManager.newSectionElements.push(lineElement);
                    lineElement.currentRenderMaterial = GraphicsMaterials.redMaterial;
                }
                else
                {
                  this.assetManager.newSectionElements.splice(index, 1);
                  lineElement.currentRenderMaterial = lineElement.defaultMaterial
                }
              }
              else if(this.assetManager.functionalityMode == 'JOINFLANGES' && lineElement.properties ){
                if(this.assetManager.joinFlanges == null)
                  this.assetManager.joinFlanges = []
                let index = this.assetManager.joinFlanges.findIndex(x => x.Guid === lineElement.Guid);
                if(index === -1)
                {
                    this.assetManager.joinFlanges.push(lineElement);
                    lineElement.currentRenderMaterial = GraphicsMaterials.redMaterial;
                }
                else
                {
                  this.assetManager.joinFlanges.splice(index, 1);
                  lineElement.currentRenderMaterial = lineElement.defaultMaterial
                }
              }

              // this.graphicsMaterials.setSurfaceElementAsSelected(lineElement);
              this._selectedObject = lineElement
              this._selectedWorkableElement = lineElement
              this._selectedObject.mode = asset.mode
              this.assetManager.currentSelectedElement = lineElement
              // this.graphics.outlinePass.selectedObjects = [lineElement.SurfaceDesign]
              this.graphics.outlineElement([lineElement.SurfaceDesign])
              const center = lineElement.getCenter()
              this.elementList = this.sortlistDistances(center, linearGeometrics)
              this.elementInZoomWasCleaned = false

              // console.log("lineElement",lineElement)

              if(lineElement.completeIdElements === null || lineElement.completeIdElements.length === 0){
                if(lineElement.TypeId === ELEMENTSTYPESIDS.STIFFENER &&
                   (lineElement.properties?.General.CompleteStiffenerId || lineElement.properties?.General.FullStiffenerId)){
                  let elements = section?.linearElements?.filter((x) => x.Guid !== lineElement.Guid &&
                    x.properties?.General.CompleteStiffenerId === lineElement.properties?.General.CompleteStiffenerId);
                  // console.log("lineElement.fullIdElements",lineElement.completeIdElements)
                  if(!elements || elements.length === 0){
                    elements = section?.linearElements?.filter((x) =>
                      x.properties?.General.FullStiffenerId === lineElement.properties?.General.FullStiffenerId);
                  }
                  elements = elements.sort((a: LinearElement, b: LinearElement) => a.Area - b.Area);
                  lineElement.completeIdElements = elements;
                }
                else if(lineElement.TypeId === ELEMENTSTYPESIDS.BRACKET &&
                  (lineElement.properties?.General.CompleteBracketId || lineElement.properties?.General.FullBracketId)){
                  let elements = section?.linearElements?.filter((x) => x.Guid !== lineElement.Guid &&
                    x.properties?.General.CompleteBracketId === lineElement.properties?.General.CompleteBracketId);
                  if(!elements || elements.length === 0){
                    elements = section?.linearElements?.filter((x) =>
                      x.properties?.General.FullBracketId === lineElement.properties?.General.FullBracketId);
                    elements = elements.sort((a: LinearElement, b: LinearElement) => a.Area - b.Area);
                  }
                  lineElement.completeIdElements = elements;
                }

              }
              // console.log("lineElement guid - ",lineElement.Guid)

            }
          }
        }
      }
      if (this._selectedObject != null && this.assetManager.functionalityMode == "MULTIPLESTRUCTURESELECTION") {
        if (this.assetManager.selectedElements.find(e => e.Guid == elementId) == undefined) {
          this.assetManager.selectedElements = [this._selectedObject, ...this.assetManager.selectedElements]
        }
      }
    }
  }

  private toggleMergePlateSelection(element: WorkableElement, asset: Asset): void {
    const isPlate = element.TypeId === ELEMENTSTYPESIDS.PLATE;
    if (!isPlate) {
      this.noticationService.addErrorNotification('Only plates can be selected for merge');
      this.syncMergePlateSelection(asset);
      return;
    }

    const platesToMerge = this.assetManager.platesToMerge ?? [];
    this.assetManager.platesToMerge = platesToMerge;

    const index = platesToMerge.findIndex(plate => plate.Guid === element.Guid);
    if (index >= 0) {
      platesToMerge.splice(index, 1);
      element.currentRenderMaterial = element.defaultMaterial;
    }
    else {
      const firstPlate = platesToMerge[0];
      if (firstPlate &&
        (firstPlate.regionId !== element.regionId || firstPlate.SectionId !== element.SectionId)) {
        this.noticationService.addErrorNotification('Select plates from the same region and section');
        this.syncMergePlateSelection(asset);
        return;
      }

      if (platesToMerge.length >= 2) {
        this.noticationService.addErrorNotification('Two plates are already selected. Deselect one before continuing');
        this.syncMergePlateSelection(asset);
        return;
      }

      platesToMerge.push(element);
    }

    this.assetManager.setMergeFinished(platesToMerge.length === 2);
    this.syncMergePlateSelection(asset);
  }

  private syncMergePlateSelection(asset: Asset): void {
    const platesToMerge = this.assetManager.platesToMerge ?? [];
    platesToMerge.forEach(plate => plate.currentRenderMaterial = GraphicsMaterials.redMaterial);

    const selectedPlate = platesToMerge[platesToMerge.length - 1] ?? null;
    this._selectedObject = selectedPlate;
    this._selectedWorkableElement = selectedPlate;
    this.selectedId = selectedPlate?.Guid ?? '';

    if (!selectedPlate) {
      this.assetManager.currentSelectedElement = null;
      this.graphics.clearOutlinedElements();
      return;
    }

    this._selectedObject.mode = asset.mode;
    this.assetManager.currentSelectedElement = selectedPlate;
    this.graphics.outlineElement([selectedPlate.SurfaceDesign]);
    GraphicsMaterials.bringElementToFront(selectedPlate);
  }

  public markMultipleElementsSelected(ids: string[], asset: Asset, asSecondary = true) {
    // Work on a copy: callers may keep using their array after this call.
    const elementIds = [...(ids ?? [])]
    var first = elementIds.shift()
    if (first) this.markElementSelected(first, asset);

    if (elementIds.length == 0) return;
    var surfacesToOutline: THREE.Object3D[] = []

    this.changesWorkflowService.clearChanges()
    const regionsSelected = asset.GetVisibleRegionsAllTypes()
    if (regionsSelected) {
      for (const regionGroup of regionsSelected) {
        let section = null
        if (this.selectedObject.parent) {
          section = regionGroup.sections.find(
            (x) => x.Guid === this.selectedObject.parent.parent.name,
          )
        } else {
          section = regionGroup.sections.find(
            (x) => x.Guid === this.assetManager.currentSection.Guid,
          )
        }
        if (section) {
          const elements = (section?.surfaceElements as (any[]))?.filter((x) => elementIds.includes(x.Guid))
          for (const element of elements) {
            // Phase 4 (SEL-04): GaugingElement multi-select uses proxy for OutlinePass.
            if (element instanceof GaugingElement) {
              const proxy = this.instanceManager.acquireProxy(element as GaugingElement, this.graphics.scene);
              if (proxy) {
                surfacesToOutline.push(proxy);
              } else {
                surfacesToOutline.push(element.SurfaceDesign);
              }
            } else {
              surfacesToOutline.push(element.SurfaceDesign)
            }
          }
          const lineElements: any[] = section?.linearElements?.filter((x) => elementIds.includes(x.Guid))
          if (lineElements.length > 0) {
            for (const lineElement of lineElements) {
              surfacesToOutline.push(lineElement.SurfaceDesign)
            }
          }
        }
      }
    }
    if (surfacesToOutline.length > 0) {
      if (asSecondary) {
        this.graphics.outlineSecondaryElement(surfacesToOutline)
      }
      else {
        surfacesToOutline.push(...this.graphics.getOutlinedElements())
        this.graphics.outlineElement(surfacesToOutline)
      }
    }
  }

  public markSecondaryElementsSelected(elementIds: string[], asset: Asset) {
    if (elementIds.length == 0) return;

    this.changesWorkflowService.clearChanges()
    const regionsSelected = asset.GetVisibleRegionsAllTypes()
    if (regionsSelected) {
      for (const regionGroup of regionsSelected) {
        let section = null
        // Same resolution chain as markElementSelected: legacy parent chain,
        // then currentSection, then any visible section containing the ids.
        const parentSectionId = this.selectedObject?.parent?.parent?.name
        if (parentSectionId) {
          section = regionGroup.sections.find((x) => x.Guid === parentSectionId)
        }
        if (!section) {
          const currentSectionId = this.assetManager.currentSection?.Guid
          if (currentSectionId) {
            section = regionGroup.sections.find((s) => s.Guid === currentSectionId)
          }
        }
        if (!section || !(section.surfaceElements as any[])?.some((x) => elementIds.includes(x.Guid))) {
          section = regionGroup.sections.find(
            (s) => s.visible !== false && (s.surfaceElements as any[])?.some((x) => elementIds.includes(x.Guid)),
          ) ?? section
        }
        if (section) {
          const elements = (section?.surfaceElements as (any[]))?.filter((x) => elementIds.includes(x.Guid))
          if (elements?.length > 0) {
            for (const element of elements) {
              // Phase 4 (SEL-04): GaugingElement secondary selection uses proxy for OutlinePass.
              if (element instanceof GaugingElement) {
                const proxy = this.instanceManager.acquireProxy(element as GaugingElement, this.graphics.scene);
                if (proxy) {
                  this.graphics.addSecondaryOutlineElement(proxy);
                } else {
                  this.graphics.addSecondaryOutlineElement(element.SurfaceDesign);
                }
              } else {
                this.graphics.addSecondaryOutlineElement(element.SurfaceDesign)
              }
            }
          } else {
            const lineElements: any[] = section?.linearElements?.filter((x) => elementIds.includes(x.Guid))
            if (lineElements?.length > 0) {
              for (const lineElement of lineElements) {
                this.graphics.addSecondaryOutlineElement(lineElement.SurfaceDesign)
              }
            }
          }
        }
      }
    }
  }

  public clearElementSelected(sectionId: string, asset: Asset, alsoSecondary = true): void {
    const sectionSelected = asset.GetVisibleRegions()
    if (sectionSelected) {
      if (this.selectedObject?.parent) {
        for (const regionGroup of sectionSelected) {
          this.graphicsMaterials.clearElementAsSelected(
            regionGroup,
            this.selectedObject.parent.name,
            this.selectedId,
          )
        }
      } else if (this.assetManager.currentSelectedElement?.SectionId) {
        for (const regionGroup of sectionSelected) {
          this.graphicsMaterials.clearElementAsSelected(
            regionGroup,
            this.assetManager.currentSelectedElement.SectionId,
            this.assetManager.currentSelectedElement.Guid,
          )
        }
      }
    }
    GraphicsMaterials.restoreElementToNormal(this.assetManager.currentSelectedElement);
    this.restoreMultiSelectedElements()
    // Nothing selected any more: leave "Select more" so its type filter never lingers.
    this.assetManager.endMultiSelectEdit()
    this.assetManager._setSelectedInspectionElement(null)
    this._selectedObject = null
    this.selectedId = ''
    this.assetManager.currentSelectedElement = null
    this.assetManager.selectedElements = []
    // Phase 4 (SEL-04): release all active outline proxies back to pool.
    // This must happen BEFORE clearOutlinedElements empties selectedObjects,
    // so that proxy references are returned to the pool cleanly.
    this.instanceManager.releaseAllProxies();
    // this.graphics.outlinePass.selectedObjects = []
    this.graphics.clearOutlinedElements(alsoSecondary)
    if (alsoSecondary) {
      this.assetManager.tempInsertedPointsArray = []
      this.assetManager.selectedInspections = []
    }
    this.elementList = []
    // this.selectedElementInZoom = []
    this.elementInZoomWasCleaned = true
  }

  public clearAllElementSelected(asset: Asset): void {
    var sectionSelected
    if (this._asset.isLightModel && this._asset.mode == "MODEL") {
      sectionSelected = asset.GetLightModelRegions()
    }
    else {
      sectionSelected = asset.GetAllStructureRegions()
    }
    if (sectionSelected) {
      for (const region of sectionSelected) {
        region.setBackToDefaultMaterial()
      }
      this.clearSectionSelected(this.selectedId, asset)
    }
    this.restoreMultiSelectedElements()
    this.assetManager.endMultiSelectEdit()
    this.assetManager._setSelectedInspectionElement(null)
    this._selectedObject = null
    this.selectedId = ''
    this.assetManager.currentSelectedElement = null
    this.assetManager.selectedElements = []
    // Phase 4 (SEL-04): release all active outline proxies back to pool before clearing outlined elements.
    this.instanceManager.releaseAllProxies();
    // this.graphics.outlinePass.selectedObjects = []
    this.graphics.clearOutlinedElements()
  }

  /**
   * In a multi-selection every element was brought to front when it was the
   * primary; put all of them back (the current primary is handled by the caller).
   */
  private restoreMultiSelectedElements(): void {
    const current = this.assetManager.currentSelectedElement
    for (const element of this.assetManager.selectedElements ?? []) {
      if (element !== current && element?.materialBeforeFront) {
        GraphicsMaterials.restoreElementToNormal(element)
      }
    }
  }

  private hideElementSelected(sectionId: string, asset: Asset): void {
    this.clearElementSelected(sectionId, asset)
    const sectionSelected = asset.GetVisibleRegions()
    this.selectedObject.visible = false
    // PhantomSurfaceDesign (instanced inspection points) has no parent chain —
    // resolve region/section ids phantom-safely instead of dereferencing
    // selectedObject.parent (null for phantoms, which threw and aborted the hide).
    const ids = this.findRegionAndSectionIds(this.selectedObject, asset)
    const state = this.assetStateCapture.captureHideState(
      asset,
      this.selectedObject,
      this.selectedObject.name,
      ids.regionId,
      ids.sectionId,
    )
    this.assetStateManager.pushState(state)
    this.selectedId = ''
  }
  //#endregion

  private createAssetState(
    regions: { [id: string]: { visible?: boolean; sections?: { [id: string]: boolean } } },
    sections: Array<{ id: string; visible: boolean }>,
    elementId: string,
    object: THREE.Object3D,
    mode: Modes,
    viewMode: ViewModes,
    visualizationMode: VisualizationMode,
    action: ActionType,
    setCamera?: boolean,
  ): AssetState {
    const assetState: AssetState = new AssetState()
    assetState.position = this.camera.position.clone()
    assetState.target = this.controls.target.clone()

    let regs = regions
    if (!regs || typeof regs !== 'object' || Array.isArray(regs)) {
      regs = {}
      const visibleRegionGroups = this._asset.isLightModel && this._asset.mode === 'MODEL'
        ? this._asset.GetLightModelRegions()
        : this._asset.GetAllStructureRegions()
      if (visibleRegionGroups) {
        for (const visibleRegionGroup of visibleRegionGroups) {
          const secs: { [id: string]: boolean } = {}

          visibleRegionGroup?.sections.forEach((section) => {
            secs[section.Guid] = section.visible
          })

          regs[visibleRegionGroup.Guid] = {}
          regs[visibleRegionGroup.Guid].visible = visibleRegionGroup.visible
          regs[visibleRegionGroup.Guid].sections = secs
        }
      }
    }

    assetState.regions = regs
    assetState.regionId = this.assetManager.currentRegion?.Guid
    assetState.sections = sections
    assetState.sectionId = this.assetManager.currentSection?.Guid
    assetState.elementId = elementId

    assetState.box3 = this._asset.box3

    assetState.object = object
    assetState.objectVisibility = object?.visible

    assetState.mode = mode
    assetState.viewMode = viewMode
    assetState.visualizationMode = visualizationMode
    assetState.action = action

    return assetState
  }

  public getRegionProperties(regionId: string): any {
    return this._asset.assetInfo.Regions.find((x) => x.id == regionId)?.properties
  }

  public getSectionProperties(sectionId: string): any {
    return this._asset.assetInfo.Sections.find((x) => x.id == sectionId)?.properties
  }

  public axesClick(
    event,
    axesScene: THREE.Group,
    asset: Asset,
    camera: THREE.Camera,
    offsetX: number,
  ) {
    let clientX, clientY;
    if (event.clientX == undefined) {
      clientX = event.center.x;
      clientY = event.center.y;
    } else {
      clientX = event.clientX;
      clientY = event.clientY;
    }

    // Robustly calculate mouse coordinates relative to the axes canvas
    const targetElement = event.srcEvent ? (event.srcEvent.target as HTMLElement) : (event.target as HTMLElement);
    const rect = targetElement.getBoundingClientRect();

    const x = clientX - rect.left;
    const y = clientY - rect.top;

    const mouse3D = new THREE.Vector3(
      (x / rect.width) * 2 - 1,
      -(y / rect.height) * 2 + 1,
      0.5
    );
    const mouse2D = new THREE.Vector2(mouse3D.x, mouse3D.y)

    const newCamera = camera.clone()
    const axesRaycaster = new THREE.Raycaster()
    axesRaycaster.tolerance = 0
    axesRaycaster.setFromCamera(mouse2D, newCamera)

    const axesIntersect = axesRaycaster.intersectObjects(axesScene.children)

    if (axesIntersect.length > 0) {
      const box = asset.getVisibleBox()
      switch (axesIntersect[0].object.name) {
        case 'Face X Positive':
          this.changeTopArrow('TOP')
          this.changeBottomArrow('BOT')
          this.changeLeftArrow('SB')
          this.changeRightArrow('PS')
          this.cameraControl.setcanonicalCameraForSection(box, new THREE.Vector3(1, 0, 0))
          // console.log(this.camera.position.x, ',', this.camera.position.y, ' ,', this.camera.position.z)
          break
        case 'Face X Negative':
          this.changeTopArrow('TOP')
          this.changeBottomArrow('BOT')
          this.changeLeftArrow('PS')
          this.changeRightArrow('SB')
          this.cameraControl.setcanonicalCameraForSection(box, new THREE.Vector3(-1, 0, 0))
          break
        case 'Face Y Positive':
          this.changeTopArrow('TOP')
          this.changeBottomArrow('BOT')
          this.changeLeftArrow('FWD')
          this.changeRightArrow('AFT')
          this.cameraControl.setcanonicalCameraForSection(box, new THREE.Vector3(0, 1, 0))
          break
        case 'Face Y Negative':
          this.changeTopArrow('TOP')
          this.changeBottomArrow('BOT')
          this.changeLeftArrow('AFT')
          this.changeRightArrow('FWD')
          this.cameraControl.setcanonicalCameraForSection(box, new THREE.Vector3(0, -1, 0))
          break
        case 'Face Z Positive':
          this.changeTopArrow('PS')
          this.changeBottomArrow('SB')
          this.changeLeftArrow('AFT')
          this.changeRightArrow('FWD')
          this.cameraControl.setcanonicalCameraForSection(box, new THREE.Vector3(0, 0, 1))
          break
        case 'Face Z Negative':
          this.changeTopArrow('SB')
          this.changeBottomArrow('PS')
          this.changeLeftArrow('AFT')
          this.changeRightArrow('FWD')
          this.cameraControl.setcanonicalCameraForSection(box, new THREE.Vector3(0, 0, -1))
          break
        default:
          break
      }
    }
  }

  public changeTopArrow(name) {
    var element = document.getElementById('topArrow')
    this.changeArrow(element, name)
  }

  public changeBottomArrow(name) {
    var element = document.getElementById('bottomArrow')
    this.changeArrow(element, name)
  }

  public changeRightArrow(name) {
    var element = document.getElementById('rightArrow')
    this.changeArrow(element, name)
  }

  public changeLeftArrow(name) {
    var element = document.getElementById('leftArrow')
    this.changeArrow(element, name)
  }

  public changeArrow(element, name) {
    if (element) {
      ; (element as any).style.opacity = 1
        ; (element.firstChild.lastChild as any).innerHTML = name

      setTimeout(() => {
        ; (element as any).style.opacity = 0
          ; (element as any).style.transition = 'opacity 0.5s ease-in-out'
      }, 2000)
    }
  }

  private oldMousePosition: THREE.Vector3 = null
  private elementIndex: number = 0
  // private campaignIndex: number = 0;
  private selectionIdsTabuList: Array<string>
  private anotherType: boolean = false
  // private lastElementSelected: WorkableElement = null;

  /**
   * Handles element selection with cycling support when clicking the same position repeatedly.
   *
   * Selection behavior:
   * - First click: Selects the highest priority element at that position
   * - Subsequent clicks at same position: Cycles through elements in this order:
   *   1. Remaining elements of the same campaign type (same as currently selected)
   *   2. Elements of different campaign types (following campaignTypes priority order)
   *   3. Within each campaign type, respects elementTypePriority order
   * - Click at different position: Resets cycling and selects highest priority element
   */
  private checkIntersection(
    intersects: THREE.Intersection[],
    mouse3D: THREE.Vector3,
    asset: Asset,
  ): THREE.Intersection {
    let workableElements = this.buildWorkableElementsFromIntersections(intersects, asset)
    // While inserting, the element type selector also constrains selection: only
    // structural elements of the chosen type are selectable (inspection points and
    // other campaign elements stay selectable — the pivot flow needs them).
    if (
      asset.mode === 'SECTIONS' &&
      (this.assetManager.functionalityMode === 'INSPECTIONINSERTION' ||
        this.assetManager.functionalityMode === 'ELEMENTINSERTION')
    ) {
      if (this.assetManager.auxiliaryOptionForInsertionAndSelection === 'Set Pivot Point') {
        // Pivot targets are inspection points — structure is not selectable at all.
        workableElements = workableElements.filter((w) => w instanceof GaugingElement)
      } else {
        const chosenType = this.assetManager.elementTypeForInsertionAndSelection
        workableElements = workableElements.filter(
          (w) =>
            w.Campaign?.Type?.toString() !== 'StructureCampaign' ||
            w.properties?.TypeName === chosenType,
        )
      }
    }
    // "Select more" Structure Type filter: a structural element of a type the user did not
    // allow is not a hit (so the tap falls through to an allowed element behind it), unless
    // it is already selected and the tap is meant to remove it.
    if (asset.mode === 'SECTIONS' && this.assetManager.multiSelectEditActive) {
      const selectedIds = new Set((this.assetManager.selectedElements ?? []).map(e => e.Guid))
      if (this.assetManager.currentSelectedElement) selectedIds.add(this.assetManager.currentSelectedElement.Guid)
      workableElements = workableElements.filter(
        (w) =>
          !(w instanceof StructuralElement) ||
          selectedIds.has(w.Guid) ||
          this.assetManager.isTypeAllowedForMultiSelect(w),
      )
    }
    const byType = Util.groupBy(workableElements, (w) => w.Campaign.Type.toString())

    // prioritize surface element more than linear elements
    if ('StructureCampaign' in byType) {
      this.sortStructureCampaign(byType)
    }

    if (!this.oldMousePosition) {
      this.initializeSelection(mouse3D)
      return this.selectElementByPriority(workableElements, intersects)
    }

    if (this.oldMousePosition != null) {
      const distance = this.oldMousePosition.distanceTo(mouse3D)
      if (distance < 0.05) {
        return this.cycleToNextElement(byType, intersects)
      } else {
        this.resetSelection(mouse3D)
        return this.selectElementForNewPosition(workableElements, byType, intersects)
      }
    }
  }

  private checkIntersectionOnLightModel(
    intersects: THREE.Intersection[],
    mouse3D: THREE.Vector3,
    asset: Asset,
  ): THREE.Intersection {
    const workableElements = new Array<NonWorkableElement>()

    var temporalElementIndex = intersects.findIndex(x => asset.returnModelTemporalElement(x.object.name) !== undefined);
    var temporalElement = intersects.find(x => asset.returnModelTemporalElement(x.object.name) !== undefined);
    // const distancesToRayOrigin = new Array<number>();
    if(temporalElementIndex !== -1 && (Util.isNullOrUndefined(this.selectedObject) ||
       this.selectedObject.name != intersects[temporalElementIndex].object.name)){
      return intersects[temporalElementIndex];
    }

    return intersects[0];
  }

  private sortStructureCampaign(byType: Record<string, WorkableElement[]>) {
    byType['StructureCampaign'].sort((a, b) => {
      if (!(a instanceof LinearElement) && !(b instanceof LinearElement)) {
        if (a.SurfaceDesign.userData.distance < b.SurfaceDesign.userData.distance) {
          return -1
        }
        return 0
      } else if (!(a instanceof LinearElement) && b instanceof LinearElement) {
        if (
          Math.abs(a.SurfaceDesign.userData.distance - b.SurfaceDesign.userData.distance) < 0.25
        ) {
          return -1
        }
        return 0
      }
    })
  }

  private initializeSelection(mouse3D: THREE.Vector3): void {
    this.selectionIdsTabuList = new Array<string>()
    this.oldMousePosition = mouse3D
    this.elementIndex = 0
  }

  private resetSelection(mouse3D: THREE.Vector3): void {
    this.oldMousePosition = mouse3D
    this.elementIndex = 0
  }

  private selectElementByPriority(
    workableElements: WorkableElement[],
    intersects: THREE.Intersection[]
  ): THREE.Intersection {
    const sortedList = this.sortElementsByPriority(workableElements)
    return intersects.find((x) => x.object.name === sortedList[0]?.Guid)
  }

  private sortElementsByPriority(workableElements: WorkableElement[]): WorkableElement[] {
    return workableElements.sort((a, b) => {
      const aType = getElementTypeForPriority(a)
      const bType = getElementTypeForPriority(b)

      const aIndex = elementTypePriority.indexOf(aType as any)
      const bIndex = elementTypePriority.indexOf(bType as any)

      if (aIndex !== -1 && bIndex !== -1) {
        return aIndex - bIndex
      }

      if (aIndex !== -1) return -1
      if (bIndex !== -1) return 1

      return 0
    })
  }

  private selectElementForNewPosition(
    workableElements: WorkableElement[],
    byType: Record<string, WorkableElement[]>,
    intersects: THREE.Intersection[]
  ): THREE.Intersection {
    if (this._selectedWorkableElement instanceof WorkableElement) {
      const relatedElement = this.findRelatedElement(workableElements, byType, intersects)
      if (relatedElement) {
        return relatedElement
      }
    }

    return this.selectElementByPriority(workableElements, intersects) ||
           this.selectElementByCampaignTypePriority(byType, intersects)
  }

  private findRelatedElement(
    workableElements: WorkableElement[],
    byType: Record<string, WorkableElement[]>,
    intersects: THREE.Intersection[]
  ): THREE.Intersection {
    const byExactType = Util.groupBy(workableElements, (w) => getElementTypeForPriority(w))
    const selectedElementType = getElementTypeForPriority(this._selectedWorkableElement)

    const sameExactTypeElements = byExactType[selectedElementType]?.filter(
      (x) => x.Guid !== this._selectedWorkableElement.Guid,
    )

    if (sameExactTypeElements?.length > 0) {
      return intersects.find((x) => x.object.name === sameExactTypeElements[0].Guid)
    }

    const currentTypeIndex = elementTypePriority.indexOf(selectedElementType as any)
    if (currentTypeIndex !== -1) {
      for (let i = 0; i < elementTypePriority.length; i++) {
        if (i !== currentTypeIndex) {
          const priorityType = elementTypePriority[i]
          if (byExactType[priorityType]?.length > 0) {
            return intersects.find((x) => x.object.name === byExactType[priorityType][0].Guid)
          }
        }
      }
    }

    const typeKey = this._selectedWorkableElement.Campaign.Type.toString()
    const sameCampaignTypeElements = byType[typeKey]?.filter(
      (x) => x.Guid !== this._selectedWorkableElement.Guid,
    )

    if (sameCampaignTypeElements?.length > 0) {
      return intersects.find((x) => x.object.name === sameCampaignTypeElements[0].Guid)
    }

    return this.findFirstElementOfDifferentType(byType, intersects)
  }

  private selectElementByCampaignTypePriority(
    byType: Record<string, WorkableElement[]>,
    intersects: THREE.Intersection[]
  ): THREE.Intersection {
    for (const type of campaignTypes) {
      if (type in byType) {
        const intersection = intersects.find((x) => x.object.name === byType[type][0]?.Guid)
        if (intersection) {
          return intersection
        }
      }
    }
    return null
  }

  private buildWorkableElementsFromIntersections(
    intersects: THREE.Intersection[],
    asset: Asset
  ): WorkableElement[] {
    const workableElements = new Array<WorkableElement>()

    for (const intersected of intersects) {
      let elementId: string;
      let sectionId: string;

      if (asset.isNewModelMode && asset.mode === 'REGIONS') {
        const ids = this.findRegionAndSectionIds(intersected.object, asset);
        sectionId = ids.sectionId;
        elementId = intersected.object.name;
      } else {
        elementId = intersected.object.name;
        sectionId = intersected.object.parent.parent.name;
      }

      const workableElement = this.intersectionToObject(
        asset,
        elementId,
        sectionId,
      )

      if (workableElement && !workableElements.some(x => x.Guid === workableElement.Guid)) {
        workableElement.SurfaceDesign.userData.distance = intersected.distance
        workableElements.push(workableElement)
      }
    }

    return workableElements
  }

  private cycleToNextElement(
    byType: Record<string, WorkableElement[]>,
    intersects: THREE.Intersection[],
  ): THREE.Intersection {
    if ('InspectionCampaign' in byType) {
      byType['InspectionCampaign'] = byType['InspectionCampaign'].sort((a, b) => {
        if (a.Campaign.Type === 'InspectionCampaign' && b.Campaign.Type === 'InspectionCampaign') {
          if (a instanceof GaugingPoint) {
            return -1
          } else if (b instanceof GaugingPoint) {
            return 1
          } else {
            return 0
          }
        }
        return a.date < b.date ? 1 : b.date < a.date ? -1 : 0
      })
    }

    const currentTypeKey = this._selectedWorkableElement?.Campaign.Type.toString()
    const currentTypeElements = byType[currentTypeKey]

    if (currentTypeElements && currentTypeElements.length > 0) {
      this.elementIndex++

      if (this.elementIndex < currentTypeElements.length) {
        const nextElement = currentTypeElements[this.elementIndex]
        return intersects.find((x) => x.object.name === nextElement.Guid)
      }
    }

    this.elementIndex = 0
    return this.findFirstElementOfDifferentType(byType, intersects)
  }

  private findFirstElementOfDifferentType(
    byType: Record<string, WorkableElement[]>,
    intersects: THREE.Intersection[],
  ): THREE.Intersection {
    const currentCampaignType = this._selectedWorkableElement?.Campaign.Type
    const currentTypeIndex = campaignTypes.indexOf(currentCampaignType)

    const nextElement = this.findElementInCampaignTypeRange(
      byType,
      intersects,
      currentTypeIndex + 1,
      campaignTypes.length
    )

    if (nextElement) {
      return nextElement
    }

    return this.findElementInCampaignTypeRange(
      byType,
      intersects,
      0,
      campaignTypes.length
    )
  }

  private findElementInCampaignTypeRange(
    byType: Record<string, WorkableElement[]>,
    intersects: THREE.Intersection[],
    startIndex: number,
    endIndex: number
  ): THREE.Intersection {
    for (let i = startIndex; i < endIndex; i++) {
      const campaignType = campaignTypes[i]

      if (campaignType in byType) {
        const elementsOfType = byType[campaignType]
        const byExactType = Util.groupBy(elementsOfType, (w) => w.constructor.name)

        for (const elementType of elementTypePriority) {
          if (byExactType[elementType]?.length > 0) {
            const element = byExactType[elementType][0]
            const intersection = intersects.find((x) => x.object.name === element.Guid)
            if (intersection) {
              return intersection
            }
          }
        }

        const firstElement = elementsOfType[0]
        const intersection = intersects.find((x) => x.object.name === firstElement.Guid)
        if (intersection) {
          return intersection
        }
      }
    }

    return null
  }

  private intersectionToObject(
    asset: Asset,
    elementId: string,
    sectionId: string,
  ): WorkableElement {
    const regionsSelected = asset.GetVisibleRegionsAllTypes()
    if (regionsSelected) {
      for (const regionGroup of regionsSelected) {
        const section = regionGroup.sections.find((x) => x.Guid === sectionId)
        if (section) {
          const element = section?.surfaceElements?.find((x) => x.Guid === elementId)
          if (element) {
            return element
          } else {
            const lineElement = section?.linearElements?.find((x) => x.Guid === elementId)
            if (lineElement) {
              return lineElement
            }
          }
        }
      }
    }
    return null
  }

  private sorted = false;

  public sortlistDistances(center: THREE.Vector3, geometrics: Array<GeometricElement>): Array<GeometricElement> {
    if (this.sorted) {
      return geometrics;
    }

    const sortedList = geometrics.sort((a, b) => {
      const distanceA = center.distanceTo(a.getCenter());
      const distanceB = center.distanceTo(b.getCenter());
      return distanceA - distanceB;
    });

    this.sorted = true;
    return sortedList;
  }

  repositionCamera(switchView: boolean = true) {
    var selectedObject = this.selectedWorkableElement as StructuralElement;
    var normal = selectedObject?.elementNormal?.clone() ?? selectedObject?.sectionNormal?.clone();

    if (selectedObject) {
      this.assetManager.isNavigationSectionAvailable = false;
      var bbox = selectedObject.SurfaceDesign.geometry.boundingBox.clone()

      if (selectedObject instanceof SteelThicknessGaugingPoint) {
        if (selectedObject.targetElements.length >= 1) {
          normal = selectedObject.targetElements[0].elementNormal.clone()
        } else {
          if (selectedObject.targetElement != null) {
            normal = selectedObject.targetElement.elementNormal.clone()
          }
        }
        let size = new THREE.Vector3()
        bbox.getSize(size)
        const v = selectedObject.elementResult.ElementInfo.vertices
        if (v.length == 3) {
          let center = new THREE.Vector3(v[0], v[1], v[2])
          bbox.setFromCenterAndSize(center, size)
        }
      }

      if (switchView) {
        if (this.lastSelectedObject === selectedObject) {
          this.lastViewIsA = !this.lastViewIsA;
        } else {
          this.lastSelectedObject = selectedObject;
          this.lastViewIsA = true;
        }

        if (!this.lastViewIsA) {
          normal = this.invertVector(normal);
        }
      } else {
        if (this.lastSelectedObject !== selectedObject) {
          this.lastSelectedObject = selectedObject;
        }
      }

      this.cameraControl.setCameraForSection(bbox, normal, 0);
    } else {
      if (!selectedObject || this.elementInZoomWasCleaned == true && selectedObject) {
        this.assetManager.isNavigationSectionAvailable = !this.assetManager.isNavigationSectionAvailable;
      }
    }
  }

  invertVector(vector: THREE.Vector3): THREE.Vector3 {
    return new THREE.Vector3(-vector.x, -vector.y, -vector.z);
  }



  public selectSensor(sensor: BasicSensor): void {
    this._selectedObject = sensor
    this.selectedObject = sensor
    this._selectedWorkableElement = sensor
    //this._selectedObject.mode = sensor.properties.asset.mode
    this.assetManager.currentSelectedElement = sensor
    // this.graphics.outlinePass.selectedObjects = [sensor.SurfaceDesign]
    this.graphics.outlineElement([sensor.SurfaceDesign])
    this.setSelectSection(this._selectedObject.regionId, this._selectedObject.sectionId, this._selectedObject.assetId)
    //SensorPropertiesMapper.MapToVisualizationMode(this._selectedObject.sensorProperties);
  }

  public selectStructuralConnection(element: StructuralConnection): void {
      // this.clearAllElementSelected(this._asset); // Deselect others

      // this.selectedId = element.Guid;
      // this._selectedObject = element;

      this.selectedId = element.Guid;
      this._selectedObject = element
      this.selectedObject = element
      this._selectedWorkableElement = element
      this.assetManager.currentSelectedElement = element

      // Visual feedback (outline)
      this.graphics.outlineElement([element.SurfaceDesign]);

      // Optional: Notify the component (e.g., via a Subject or Service)
      // You might need a ConnectionsService.notifySelection(element.connectionData)
  }

  selectElement(regionId: string, sectionId: string, elementId: string, triggerChange:boolean = true) {
    if(!elementId) {
      return;
    }

    let region = this.assetManager.asset.GetRegionsAllTypes()?.find(x => x.Guid === regionId)
    if(!region) {
      return;
    }

    let section = region.sections.find(x => x.Guid === sectionId)
    if(!section) {
      return;
    }

    let element = this.findElementInSection(section, elementId)
    if (!element) {
      return;
    }

    const geometrics = section?.surfaceElements
    this.processElementSelection(element, geometrics, triggerChange)
  }

  private findElementInSection(section: Section, elementId: string): WorkableElement {
    let element = section.surfaceElements?.find(x => x.Guid === elementId);
    if (!element) {
        element = section.linearElements?.find(x => x.Guid === elementId);
    }

    return element;
  }

  private processElementSelection(element: WorkableElement, geometrics: WorkableElement[], triggerChange:boolean = true) {
    const center = element.getCenter();
    this.elementList = this.sortlistDistances(center, geometrics);
    this.elementInZoomWasCleaned = false;
    this._selectedObject = element;
    this._selectedWorkableElement = element;
    this._selectedObject.mode = this.assetManager.asset.mode;
    if(triggerChange){
      this.assetManager.currentSelectedElement = element;
    }
    else{
      this.assetManager.setCurrentSelectedElement(element);
    }
    this.graphics.outlineElement([element.SurfaceDesign]);

    this.selectedId = element.Guid;
  }

  public regenerateLegendIfNeeded(asset: Asset): void {
    if (!this.shouldRegenerateLegend(asset.viewMode)) {
      return;
    }

    switch (asset.viewMode) {
      case 'ThicknessColor':
        this.graphicsMaterials.regenerateThicknessLegend(asset.GetStructureAndRepairsRegions());
        break;

      case 'MaterialColor':
        this.graphicsMaterials.regenerateMaterialsLegend(asset.GetStructureAndRepairsRegions());
        break;

      case 'RegionColor':
        this.graphicsMaterials.regenerateRegionsLegend(asset.GetStructureAndRepairsRegions());
        break;

      case 'Structure4D':
        this.graphicsMaterials.regenerateStructure4DLegend(asset.GetStructureAndRepairsRegions());
        break;

      case 'TypicalDetailsFamily':
        this.graphicsMaterials.regenerateTypicalDetailsFamilyLegend(asset.GetStructureAndRepairsRegions());
        break;

      default:
        console.warn(`ViewMode ${asset.viewMode} está na lista de regeneração mas não tem implementação específica`);
        break;
    }
  }

  private shouldRegenerateLegend(viewMode: string): boolean {
    return this.legendRegenerationViewModes.includes(viewMode);
  }

  private getFULLName(): string {
    return sessionStorage.getItem(SESSION_STORAGE.FULL_NAME);
  }

  private getCustomerId(): string {
    return sessionStorage.getItem(SESSION_STORAGE.CUSTOMER_ID);
  }

  public setTracingData(): Observable<void> {
    this.assetManager.settingTracingData = true;
    return new Observable(observer => {
      if (!this.assetManager.tracingDataLoaded) {
        const date: Date = new Date();
        const fullName = this.getFULLName();
        date.setDate((this.assetManager.referenceDate.getDate() - 30));
        let filters: TracingFilters = {}
        filters.AssetId = this.assetManager.asset.assetInfo.AssetId;
        filters.StartDate = date;
        filters.EndDate = this.assetManager.referenceDate
        filters.CustomerId = this.getCustomerId();
        filters.UserName = fullName;
        filters.PageSize = 1;

        this.tracingService.getAll(filters).subscribe({
          next: (response) => {
            this.assetManager.tracingData = response;

            if (this.assetManager.tracingData?.length > 0) {
              const filterResults = this.assetManager.tracingData.filter(x => x.userName === fullName);
              if (filterResults && filterResults.length > 0) {
                const lastTracing = filterResults[0];
                if (lastTracing.eventType.includes("Inspection") || lastTracing.eventType.includes("Spreadsheet")) {
                  this.loadCurrentCluster = true;
                }
                else {
                  this.loadCurrentCluster = false;
                }
              }
              else {
                this.loadCurrentCluster = true;
              }
            }
            this.assetManager.tracingDataLoaded = true;
            observer.next();
            observer.complete();
          },
          error: (error) => {
            observer.error(error);
          }
        });
      } else {
        observer.next();
        observer.complete();
      }
    });
  }

  /**
   * Get inspection point at the specified screen position.
   *
   * Uses InstancedMesh raycast targets instead of phantom SurfaceDesign objects
   * (SEL-03). PhantomSurfaceDesign has no geometry so the legacy path returned
   * nothing for instanced points (Pitfall 6 from research).
   *
   * Falls back to the legacy phantom-based path when no InstancedMesh targets
   * exist (non-instanced elements, if any).
   *
   * @param ev - The event containing screen coordinates
   * @returns GaugingElement if an inspection point is found at the position, null otherwise
   */
  public getInspectionPointAtPosition(ev: any): GaugingElement | null {
    // Convert screen coordinates to normalized device coordinates
    const mouse3D = new THREE.Vector3(
      ((ev.clientX ? ev.clientX : ev.center.x) - this.graphics.offsetX) / window.innerWidth * 2 - 1,
      -(((ev.clientY ? ev.clientY : ev.center.y) - this.graphics.offsetY) / window.innerHeight) * 2 + 1,
      0.5
    );
    const mouse2D = new THREE.Vector2(mouse3D.x, mouse3D.y);

    const raycaster = new THREE.Raycaster();
    raycaster.setFromCamera(mouse2D, this.graphics.camera);

    // --- InstancedMesh path (SEL-03) ---
    const targets = this.instanceManager.getRaycastTargets();
    if (targets.length > 0) {
      const hits = raycaster.intersectObjects(targets, false);
      for (const hit of hits) {
        if (hit.instanceId !== undefined) {
          const element = this.instanceManager.resolveInstance(
            hit.object as THREE.InstancedMesh,
            hit.instanceId,
          );
          if (element && this.instanceManager.getInstanceVisible(element)) {
            return element;
          }
        }
      }
      return null;
    }

    // --- Legacy fallback: phantom SurfaceDesign-based path (non-instanced elements) ---
    const inspectionElements: GaugingElement[] = [];

    this._asset.InspectionCampaigns.forEach(campaign => {
      campaign.Elements.forEach(element => {
        if (element instanceof GaugingElement) {
          inspectionElements.push(element as GaugingElement);
        }
      });
    });

    if (this.assetManager?.tempInsertedPointsArray) {
      this.assetManager.tempInsertedPointsArray.forEach(element => {
        if (element instanceof GaugingElement) {
          inspectionElements.push(element as GaugingElement);
        }
      });
    }

    const intersects = raycaster.intersectObjects(inspectionElements.map(el => el.SurfaceDesign));
    if (intersects.length > 0) {
      const closestIntersection = intersects[0];

      const foundElement = inspectionElements.find(el =>
        el.SurfaceDesign === closestIntersection.object
      );

      return foundElement || null;
    }

    return null;
  }
}
